(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["benefit-card"] && !Shopify.designMode) return;
  try {
    class PercentageCounter {
    constructor() {
      this.counters = document.querySelectorAll('.percentage-counter');
      this.init();
    }

    init() {
      if (!this.counters.length) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.animateCounter(entry.target);
              this.observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.5 }
      );

      this.counters.forEach((counter) => {
        this.observer.observe(counter);
      });
    }

    animateCounter(counter) {
      const target = parseInt(counter.dataset.target);
      const duration = 2000; // 2 seconds
      const steps = 60;
      const increment = target / steps;
      const stepDuration = duration / steps;
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        counter.textContent = Math.round(current) + '%';
      }, stepDuration);
    }
  }

  document.addEventListener('DOMContentLoaded', () => new PercentageCounter());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bottle-information-drawer-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('[data-bottle-drawer-wrapper]');

    wrappers.forEach((wrapper) => {
      const trigger = wrapper.querySelector('[data-bottle-drawer-trigger]');
      const drawer = wrapper.querySelector('[data-bottle-drawer-panel]');
      if (!trigger || !drawer) return;

      // Move drawer to body to avoid overflow-hidden breaking sticky positioning
      document.body.appendChild(drawer);

      if (window.DrawerBase) {
        window.DrawerBase.bind(drawer);
      }

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.DrawerBase) {
          window.DrawerBase.open(drawer);
        } else {
          drawer.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bottle-information-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const trigger = document.getElementById('bottle-information');
    const drawer = document.getElementById('bottle-drawer');
    if (!drawer) return;

    if (window.DrawerBase) {
      window.DrawerBase.bind(drawer);
    }

    if (trigger) {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.DrawerBase) {
          window.DrawerBase.open(drawer);
        } else {
          drawer.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bottle-selector-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-bottle-selector-v2]');

    containers.forEach((container) => {
      const colorNameEl = container.querySelector('[data-selected-color-name]');
      const radios = container.querySelectorAll('input[data-variant-switch]');
      const bundleContainer = container.closest('.bundle-select-container');

      const updateBottlePromoImages = (radio) => {
        const label = radio.closest('.swatch-label');
        if (!label) return;

        if (colorNameEl) {
          colorNameEl.textContent = label.dataset.variantTitle;
        }

        if (!bundleContainer || !label.dataset.variantImageUrl) return;

        const bottleImages = bundleContainer.querySelectorAll('[data-bottle-promo-image]');
        bottleImages.forEach((image) => {
          image.src = label.dataset.variantImageUrl;
          image.alt = label.dataset.variantImageAlt || label.dataset.variantTitle || image.alt;
        });
      };

      const checkedRadio = container.querySelector('input[data-variant-switch]:checked');
      if (checkedRadio) {
        updateBottlePromoImages(checkedRadio);
      }

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          updateBottlePromoImages(radio);
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-flavours"] && !Shopify.designMode) return;
  try {
    class BundleFlavours {
    constructor(element) {
      this.container = element;
      this.input = this.container.querySelector('[data-flavour-quantity]');
      this.valueDisplay = this.container.querySelector('[data-quantity-value]');
      this.zeroButton = this.container.querySelector('[data-quantity-zero]');
      this.decButton = this.container.querySelector('[data-quantity-dec]');
      this.incButton = this.container.querySelector('[data-quantity-inc]');
      this.productGroup = this.container.closest('[data-product-group]');
      this.totalLimit = parseInt(this.productGroup.dataset.totalLimit) || 3;

      this.#init();
      this.productGroup.addEventListener('bundle:refresh', this.#updateTotalAndVisibility.bind(this));
    }

    #init() {
      this.zeroButton.addEventListener('click', () => this.#setQuantity(1));
      this.decButton.addEventListener('click', () => this.#updateQuantity(-1));
      this.incButton.addEventListener('click', () => this.#updateQuantity(1));
      this.#updateTotalAndVisibility();
    }

    #getTotalQuantity() {
      let total = 0;
      const allInputs = this.productGroup.querySelectorAll('[data-flavour-quantity]');
      allInputs.forEach((input) => {
        total += parseInt(input.value) || 0;
      });
      return total;
    }

    #setQuantity(value) {
      const currentTotal = this.#getTotalQuantity();
      const currentValue = parseInt(this.input.value) || 0;
      const otherProductsTotal = currentTotal - currentValue;

      // Calculate how many more items we can add
      const maxAllowed = this.totalLimit - otherProductsTotal;
      const limitedValue = Math.min(value, maxAllowed);

      // Update input and display
      this.input.value = Math.max(0, limitedValue);
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.valueDisplay.textContent = String(this.input.value);

      this.#updateTotalAndVisibility();
    }

    #updateQuantity(change) {
      const currentValue = parseInt(this.input.value) || 0;
      const newValue = Math.max(0, currentValue + change);
      this.#setQuantity(newValue);
    }

    #updateTotalAndVisibility() {
      // Update the group total
      const newTotal = this.#getTotalQuantity();

      // Update all containers
      const allContainers = this.productGroup.querySelectorAll('[data-quantity-container]');
      const atLimit = newTotal >= this.totalLimit;

      allContainers.forEach((container) => {
        const input = container.querySelector('[data-flavour-quantity]');
        const quantityEl = container.querySelector('[data-quantity-value]');
        const quantity = parseInt(input.value) || 0;
        container.dataset.extended = quantity > 0 ? 'true' : 'false';
        container.dataset.disabled = atLimit ? 'true' : 'false';

        if (quantityEl) {
          quantityEl.textContent = String(quantity);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-quantity-container]');
    containers.forEach((container) => new BundleFlavours(container));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundle-plan-subscribe"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const planRadioButtons = document.querySelectorAll('input[data-plan-switch]');

    planRadioButtons.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const wrapper = event.target.closest('[data-bundle-plan-wrapper]');
        if (!wrapper) {
          return;
        }

        const containers = wrapper.querySelectorAll('[data-bundle-plan-container]');
        containers.forEach((container) => {
          container.setAttribute('data-active', 'false');
        });

        const selectedContainer = event.target.closest('[data-bundle-plan-container]');
        if (!selectedContainer) {
          return;
        }

        selectedContainer.setAttribute('data-active', 'true');
        if (!event.isTrusted) {
          return;
        }

        const planValue = event.target.value;
        const bottleSelector = wrapper.querySelector('[data-bottle-selector]');
        if (!bottleSelector) {
          return;
        }

        if (planValue === 'onetime') {
          const noBottleInput = bottleSelector.querySelector('input[type="radio"][value=""]');
          if (noBottleInput && !noBottleInput.checked) {
            noBottleInput.checked = true;
          }

          return;
        }

        if (planValue === 'subscription') {
          const firstBottleInput = bottleSelector.querySelector('input[data-variant-id]');
          if (firstBottleInput && !firstBottleInput.checked) {
            firstBottleInput.checked = true;
          }

          return;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundles-container-v2"] && !Shopify.designMode) return;
  try {
    class BundlesContainer {
    constructor(element) {
      this.container = element;
      this.#init();
    }

    #init() {
      this.dependantItems = this.container.querySelectorAll('[data-active-on-bundle]');
      this.bundleSwitches = this.container.querySelectorAll('[data-bundle-switch]');
      this.addButtons = this.container.querySelectorAll('[data-add-to-cart]');
      this.flavours = this.container.querySelectorAll('[data-flavour-quantity]');
      this.stickyButton = this.container.querySelector('[data-sticky-cta-button]');
      this.upgradeButtons = this.container.querySelectorAll('[data-upgrade]');
      this.addOns = this.container.querySelectorAll('[data-addon]');

      this.#updateDependantItems();
      this.#updateStickyFlavorBadge(this.#computeDistinctFlavorCount());
      this.#bindEvents();
      this.#updateAddToCartButton();
    }

    #bindEvents() {
      this.addOns.forEach((addOn) => {
        addOn.addEventListener('change', this.#handleAddOnChange.bind(this));
      });
      this.bundleSwitches.forEach((bundleSwitch) => {
        bundleSwitch.addEventListener('change', this.#handleBundleSwitch.bind(this));
      });
      this.flavours.forEach((flavour) => {
        flavour.addEventListener('change', this.#handleFlavourChange.bind(this));
      });
      this.upgradeButtons.forEach((button) => {
        button.addEventListener('click', this.#handleUpgradeClick.bind(this));
      });
    }

    #setActiveBundle(bundleId) {
      this.container.dataset.activeBundle = bundleId;
    }

    #getActiveBundle() {
      return this.container.dataset.activeBundle;
    }

    #updateDependantItems() {
      this.dependantItems.forEach((item) => {
        item.style.display = item.dataset.activeOnBundle === this.#getActiveBundle() ? 'block' : 'none';
      });
    }

    #updateStickyFlavorBadge(count) {
      const badge = document.querySelector('[data-sticky-flavor-count]');
      if (!badge) {
        return;
      }

      if (count > 0) {
        badge.textContent = String(count);
        badge.classList.remove('hidden');
      } else {
        badge.textContent = '';
        badge.classList.add('hidden');
      }
    }

    #handleFlavourChange(event) {
      this.#updateAddToCartButton();
    }

    #handleBundleSwitch(event) {
      const oldBundleId = this.#getActiveBundle();
      const newBundleId = event.target.value;

      this.#transferFlavours(oldBundleId, newBundleId);

      this.#setActiveBundle(newBundleId);
      // trigger parallax effect
      window.dispatchEvent(new Event('scroll'));
      this.#updateDependantItems();
      this.#updateStickyFlavorBadge(this.#computeDistinctFlavorCount());

      this.#updateAddToCartButton();
    }

    #transferFlavours(oldBundleId, newBundleId) {
      if (!oldBundleId || !newBundleId) {
        return;
      }

      if (oldBundleId === newBundleId) {
        return;
      }

      const sourceGroup = this.#getProductGroup(oldBundleId);
      const targetGroup = this.#getProductGroup(newBundleId);
      if (!sourceGroup || !targetGroup) {
        return;
      }

      const sourceInputs = this.#getGroupFlavours(sourceGroup);
      const targetInputs = this.#getGroupFlavours(targetGroup);
      const targetLimit = parseInt(targetGroup.dataset.totalLimit) || 3;

      this.#resetTargetSelections(targetInputs);

      const targetInputsByIndex = this.#buildIndexMap(targetInputs);
      const selectedSourceFlavors = this.#collectSelectedFlavors(sourceInputs);

      let currentTargetTotal = 0;
      for (const { idx, qty, sourceInput } of selectedSourceFlavors) {
        if (currentTargetTotal >= targetLimit) {
          break;
        }

        let targetInput = targetInputsByIndex[idx];
        if (!targetInput) {
          continue;
        }

        const transferableQty = Math.min(qty, targetLimit - currentTargetTotal);
        targetInput.value = String(transferableQty);
        currentTargetTotal += transferableQty;
      }

      this.#dispatchUpdateGroup(sourceGroup);
      this.#dispatchUpdateGroup(targetGroup);
    }

    #getGroupFlavours(group) {
      return Array.from(group.querySelectorAll('[data-flavour-quantity]'));
    }

    #getProductGroup(bundleId) {
      return this.container.querySelector(`[data-active-on-bundle="${bundleId}"] [data-product-group]`);
    }

    #resetTargetSelections(targetInputs) {
      targetInputs.forEach((input) => {
        input.value = '0';
      });
    }

    #buildIndexMap(inputs) {
      const map = {};
      inputs.forEach((input) => {
        const idx = parseInt(input.dataset.index);
        if (Number.isNaN(idx)) {
          return;
        }

        map[idx] = input;
      });

      return map;
    }

    #collectSelectedFlavors(inputs) {
      return inputs
        .map((input) => ({
          idx: parseInt(input.dataset.index),
          qty: parseInt(input.value) || 0,
          sourceInput: input,
        }))
        .filter(({ idx, qty }) => !Number.isNaN(idx) && qty > 0)
        .sort((a, b) => a.idx - b.idx);
    }

    #dispatchUpdateGroup(productGroup) {
      productGroup.dispatchEvent(new CustomEvent('bundle:refresh', { bubbles: true }));
    }

    #handleUpgradeClick(event) {
      const subscribableDiv = this.container.querySelector('[data-can-subscribe="true"]');
      if (!subscribableDiv) {
        return;
      }

      const newBundleId = subscribableDiv.dataset.activeOnBundle;
      const radio = this.container.querySelector(`input[data-bundle-switch][value="${newBundleId}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    #handleAddOnChange(event) {
      this.#updateAddToCartButton();
    }

    #getActiveSellingPlan() {
      const checkedBundle = this.container.querySelector('[data-bundle-switch]:checked');
      const activeSellingPlan = checkedBundle ? checkedBundle.dataset.sellingPlan || '' : '';
      return activeSellingPlan;
    }

    // goes through all container inputs and gathers data
    // required for add to cart button to create a bundle.
    #updateAddToCartButton() {
      const bundleId = this.#getActiveBundle();
      const sellingPlan = this.#getActiveSellingPlan();
      const variants = [];

      this.flavours.forEach((flavour) => {
        if (parseInt(flavour.value) == 0) {
          return;
        }

        if (bundleId !== flavour.dataset.bundleVariantId) {
          return;
        }

        for (let i = 0; i < flavour.value; i++) {
          variants.push(flavour.dataset.variantId);
        }
      });

      this.addButtons.forEach((addButton) => {
        if (bundleId !== addButton.dataset.activeOnBundle) {
          return;
        }
        console.log(addButton);

        addButton.dataset.variants = variants.join(',');

        const distinctCount = new Set(variants).size;
        this.#updateStickyFlavorBadge(distinctCount);

        if (addButton.dataset.minimumAmount) {
          const minimumAmount = parseInt(addButton.dataset.minimumAmount);
          const remainingFlavors = minimumAmount - variants.length;
          const isDisabled = variants.length < minimumAmount;
          addButton.disabled = isDisabled;
          if (this.stickyButton) {
            const defaultButtonText = isDisabled ? 'Build your Bundle' : 'Add to basket';
            const stickyText = !isDisabled && sellingPlan ? 'Subscribe now' : defaultButtonText;
            this.stickyButton.dataset.disabled = isDisabled;
            this.stickyButton.textContent = stickyText;
          }

          const buttonText = addButton.querySelector('[data-button-text]');
          if (buttonText) {
            const leftToPick = minimumAmount - variants.length;
            switch (leftToPick) {
              case 0:
                console.log(buttonText);
                buttonText.textContent = sellingPlan ? 'Subscribe now' : 'Add to basket';
                console.log(buttonText.textContent);
                break;
              case 1:
                buttonText.textContent = 'Nearly there! Add 1 more';
                break;
              case 2:
                buttonText.textContent = `Good start! Add ${remainingFlavors} more`;
                break;
              default:
                buttonText.textContent = `Pick ${minimumAmount} for your bundle`;
            }
          }
        }

        addButton.dataset.sellingPlan = sellingPlan;

        if (sellingPlan) {
          const bundleInput = this.container.querySelector(`[data-bundle-switch][value="${bundleId}"]`);
          const bundleContainer = bundleInput ? bundleInput.closest('.bundle-select-container') : null;
          const addOn = bundleContainer ? bundleContainer.querySelector('[data-addon]:checked') : null;
          if (addOn) {
            addButton.dataset.addOn = addOn.value;
          }
        } else {
          addButton.dataset.addOn = '';
        }
      });
    }

    #computeDistinctFlavorCount() {
      const bundleId = this.#getActiveBundle();
      const selected = [];
      this.flavours.forEach((flavour) => {
        if (parseInt(flavour.value) == 0) {
          return;
        }

        if (bundleId !== flavour.dataset.bundleVariantId) {
          return;
        }

        selected.push(flavour.dataset.variantId);
      });

      return new Set(selected).size;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-bundles-container-v2]');
    if (container) {
      new BundlesContainer(container);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["bundles-container"] && !Shopify.designMode) return;
  try {
    class BundlesContainer {
    constructor(element) {
      this.container = element;
      this.#init();
    }

    #init() {
      this.dependantItems = this.container.querySelectorAll('[data-active-on-bundle]');
      this.bundleSwitches = this.container.querySelectorAll('[data-bundle-switch]');
      this.addButtons = this.container.querySelectorAll('[data-add-to-cart]');
      this.flavours = this.container.querySelectorAll('[data-flavour-quantity]');
      this.stickyButton = this.container.querySelector('[data-sticky-cta-button]');
      this.upgradeButtons = this.container.querySelectorAll('[data-upgrade]');
      this.planSwitches = this.container.querySelectorAll('[data-plan-switch]');
      this.sellingPlans = this.container.querySelectorAll('[data-selling-plan]');
      this.addOns = this.container.querySelectorAll('[data-addon]');

      this.#updateDependantItems();
      this.#updateStickyFlavorBadge(this.#computeDistinctFlavorCount());
      this.#bindEvents();
      this.#updateAddToCartButton();
    }

    #bindEvents() {
      this.addOns.forEach((addOn) => {
        addOn.addEventListener('change', this.#handleAddOnChange.bind(this));
      });
      this.sellingPlans.forEach((sellingPlan) => {
        sellingPlan.addEventListener('change', this.#handleSellingPlanChange.bind(this));
      });
      this.planSwitches.forEach((planSwitch) => {
        planSwitch.addEventListener('change', this.#handlePlanSwitch.bind(this));
      });
      this.bundleSwitches.forEach((bundleSwitch) => {
        bundleSwitch.addEventListener('change', this.#handleBundleSwitch.bind(this));
      });
      this.flavours.forEach((flavour) => {
        flavour.addEventListener('change', this.#handleFlavourChange.bind(this));
      });
      this.upgradeButtons.forEach((button) => {
        button.addEventListener('click', this.#handleUpgradeClick.bind(this));
      });
    }

    #setActiveBundle(bundleId) {
      this.container.dataset.activeBundle = bundleId;
    }

    #getActiveBundle() {
      return this.container.dataset.activeBundle;
    }

    #updateDependantItems() {
      this.dependantItems.forEach((item) => {
        item.style.display = item.dataset.activeOnBundle === this.#getActiveBundle() ? 'block' : 'none';
      });
    }

    #updateStickyFlavorBadge(count) {
      const badge = document.querySelector('[data-sticky-flavor-count]');
      if (!badge) {
        return;
      }

      if (count > 0) {
        badge.textContent = String(count);
        badge.classList.remove('hidden');
      } else {
        badge.textContent = '';
        badge.classList.add('hidden');
      }
    }

    #handleFlavourChange(event) {
      this.#updateAddToCartButton();
    }

    #handleBundleSwitch(event) {
      const oldBundleId = this.#getActiveBundle();
      const newBundleId = event.target.value;

      this.#transferFlavours(oldBundleId, newBundleId);

      this.#setActiveBundle(newBundleId);
      // trigger parallax effect
      window.dispatchEvent(new Event('scroll'));
      this.#updateDependantItems();
      this.#updateStickyFlavorBadge(this.#computeDistinctFlavorCount());

      this.#updateAddToCartButton();
    }

    #transferFlavours(oldBundleId, newBundleId) {
      if (!oldBundleId || !newBundleId) {
        return;
      }

      if (oldBundleId === newBundleId) {
        return;
      }

      const sourceGroup = this.#getProductGroup(oldBundleId);
      const targetGroup = this.#getProductGroup(newBundleId);
      if (!sourceGroup || !targetGroup) {
        return;
      }

      const sourceInputs = this.#getGroupFlavours(sourceGroup);
      const targetInputs = this.#getGroupFlavours(targetGroup);
      const targetLimit = parseInt(targetGroup.dataset.totalLimit) || 3;

      this.#resetTargetSelections(targetInputs);

      const targetInputsByIndex = this.#buildIndexMap(targetInputs);
      const selectedSourceFlavors = this.#collectSelectedFlavors(sourceInputs);

      let currentTargetTotal = 0;
      for (const { idx, qty, sourceInput } of selectedSourceFlavors) {
        if (currentTargetTotal >= targetLimit) {
          break;
        }

        let targetInput = targetInputsByIndex[idx];
        if (!targetInput) {
          continue;
        }

        const transferableQty = Math.min(qty, targetLimit - currentTargetTotal);
        targetInput.value = String(transferableQty);
        currentTargetTotal += transferableQty;
      }

      this.#dispatchUpdateGroup(sourceGroup);
      this.#dispatchUpdateGroup(targetGroup);
    }

    #getGroupFlavours(group) {
      return Array.from(group.querySelectorAll('[data-flavour-quantity]'));
    }

    #getProductGroup(bundleId) {
      return this.container.querySelector(`[data-active-on-bundle="${bundleId}"] [data-product-group]`);
    }

    #resetTargetSelections(targetInputs) {
      targetInputs.forEach((input) => {
        input.value = '0';
      });
    }

    #buildIndexMap(inputs) {
      const map = {};
      inputs.forEach((input) => {
        const idx = parseInt(input.dataset.index);
        if (Number.isNaN(idx)) {
          return;
        }

        map[idx] = input;
      });

      return map;
    }

    #collectSelectedFlavors(inputs) {
      return inputs
        .map((input) => ({
          idx: parseInt(input.dataset.index),
          qty: parseInt(input.value) || 0,
          sourceInput: input,
        }))
        .filter(({ idx, qty }) => !Number.isNaN(idx) && qty > 0)
        .sort((a, b) => a.idx - b.idx);
    }

    #dispatchUpdateGroup(productGroup) {
      productGroup.dispatchEvent(new CustomEvent('bundle:refresh', { bubbles: true }));
    }

    #handleUpgradeClick(event) {
      const subscribableDiv = this.container.querySelector('[data-can-subscribe="true"]');
      if (!subscribableDiv) {
        return;
      }

      const newBundleId = subscribableDiv.dataset.activeOnBundle;
      const radio = this.container.querySelector(`input[data-bundle-switch][value="${newBundleId}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    #handleAddOnChange(event) {
      this.#selectPlan(event);
      this.#updateAddToCartButton();
    }

    #handlePlanSwitch(event) {
      this.#updateAddToCartButton();
    }

    #handleSellingPlanChange(event) {
      this.#selectPlan(event);
      this.#updateAddToCartButton();
    }

    // if event happened in one of the plan containers, then
    // automatically select the plan.
    #selectPlan(event) {
      const container = event.target.closest('[data-bundle-plan-container]');
      const plan = container.querySelector('[data-plan-switch]');
      if (plan) {
        plan.checked = true;
        plan.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // goes through all container inputs and gathers data
    // required for add to cart button to create a bundle.
    #updateAddToCartButton() {
      const bundleId = this.#getActiveBundle();
      const planContainer = this.container.querySelector(
        `[data-bundle-plans-container][data-active-on-bundle="${bundleId}"]`
      );
      const variants = [];
      let plan, sellingPlan, addOn;

      if (planContainer) {
        plan = planContainer.querySelector('[data-plan-switch]:checked');
        sellingPlan = planContainer.querySelector('[data-selling-plan]');
        addOn = planContainer.querySelector('[data-variant-switch]:checked');
      }

      this.flavours.forEach((flavour) => {
        if (parseInt(flavour.value) == 0) {
          return;
        }

        if (bundleId !== flavour.dataset.bundleVariantId) {
          return;
        }

        for (let i = 0; i < flavour.value; i++) {
          variants.push(flavour.dataset.variantId);
        }
      });

      this.addButtons.forEach((addButton) => {
        if (bundleId !== addButton.dataset.activeOnBundle) {
          return;
        }

        addButton.dataset.variants = variants.join(',');

        const distinctCount = new Set(variants).size;
        this.#updateStickyFlavorBadge(distinctCount);

        if (addButton.dataset.minimumAmount) {
          const minimumAmount = parseInt(addButton.dataset.minimumAmount);
          const remainingFlavors = minimumAmount - variants.length;
          const isDisabled = variants.length < minimumAmount;
          addButton.disabled = isDisabled;
          if (this.stickyButton) {
            const defaultButtonText = isDisabled ? 'Build your Bundle' : 'Add to basket';
            const isSubscription = plan ? plan.value === 'subscription' : false;
            const buttonText = !isDisabled && isSubscription ? 'Subscribe now' : defaultButtonText;
            this.stickyButton.dataset.disabled = isDisabled;
            this.stickyButton.textContent = buttonText;
          }

          const buttonText = addButton.querySelector('[data-button-text]');
          if (buttonText) {
            const leftToPick = minimumAmount - variants.length;
            switch (leftToPick) {
              case 0:
                buttonText.textContent = 'Add to basket';
                break;
              case 1:
                buttonText.textContent = 'Nearly there! Add 1 more';
                break;
              case 2:
                buttonText.textContent = `Good start! Add ${remainingFlavors} more`;
                break;
              default:
                buttonText.textContent = `Pick ${minimumAmount} for your bundle`;
            }
          }
        }

        if (plan) {
          addButton.dataset.sellingPlan = plan.value === 'subscription' ? sellingPlan.value : '';
        }

        addButton.dataset.addOn = addOn && plan.value === 'subscription' ? addOn.value : '';
      });
    }

    #computeDistinctFlavorCount() {
      const bundleId = this.#getActiveBundle();
      const selected = [];
      this.flavours.forEach((flavour) => {
        if (parseInt(flavour.value) == 0) {
          return;
        }

        if (bundleId !== flavour.dataset.bundleVariantId) {
          return;
        }

        selected.push(flavour.dataset.variantId);
      });

      return new Set(selected).size;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-bundles-container]');
    if (container) {
      new BundlesContainer(container);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["carousel-bundle"] && !Shopify.designMode) return;
  try {
    class CarouselBundleSwiper {
    constructor() {
      this.swiper = null;
      this.slidesPerView = 0;
      this.init();
    }

    init() {
      const swiperElement = document.querySelector('.carousel-bundle-swiper');
      if (!swiperElement) return;

      this.slidesPerView = parseInt(swiperElement.dataset.slidesPerView) || 3;
      const breakpoints = this.breakpointsConfig();
      this.swiper = new Swiper('.carousel-bundle-swiper', {
        slidesPerView: 1.1,
        spaceBetween: 16,
        grabCursor: true,
        breakpoints: breakpoints,
      });
    }

    breakpointsConfig() {
      const breakpoints = {};

      breakpoints[480] = {
        slidesPerView: 2.1,
      };

      breakpoints[768] = {
        slidesPerView: 1.1,
      };

      breakpoints[1024] = {
        slidesPerView: 2.1,
      };

      breakpoints[1280] = {
        slidesPerView: Math.min(3, this.slidesPerView),
      };

      return breakpoints;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CarouselBundleSwiper());
  } else {
    new CarouselBundleSwiper();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["club-rewards"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const wrappers = document.querySelectorAll('[data-club-rewards-wrapper]');

    wrappers.forEach((wrapper) => {
      const trigger = wrapper.querySelector('[data-club-rewards-trigger]');
      const drawer = wrapper.querySelector('[data-club-rewards-panel]');
      if (!trigger || !drawer) return;

      // Move drawer to body to avoid overflow-hidden breaking positioning
      document.body.appendChild(drawer);

      if (window.DrawerBase) {
        window.DrawerBase.bind(drawer);
      }

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.DrawerBase) {
          window.DrawerBase.open(drawer);
        } else {
          drawer.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["f1-giveaway-klaviyo-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-f1-giveaway-klaviyo-form]').forEach(function (form) {
    if (form.dataset.f1GiveawayKlaviyoFormInitialized === 'true') {
      return;
    }

    form.dataset.f1GiveawayKlaviyoFormInitialized = 'true';

    var email = form.querySelector('[data-f1-giveaway-klaviyo-email]');
    var confirmEmail = form.querySelector('[data-f1-giveaway-klaviyo-confirm-email]');
    var submitButton = form.querySelector('[data-f1-giveaway-klaviyo-submit]');
    var error = form.querySelector('[data-f1-giveaway-klaviyo-error]');
    var intro = form.parentElement.querySelector('[data-f1-giveaway-klaviyo-intro]');
    var success = form.parentElement.querySelector('[data-f1-giveaway-klaviyo-success]');
    var emailMismatchMessage = form.dataset.emailMismatchMessage || 'Email addresses must match.';
    var submitErrorMessage = form.dataset.submitErrorMessage || 'Something went wrong. Please try again.';
    var revision = '2026-04-15';

    var getField = function (name) {
      return form.querySelector('[name="' + name + '"]');
    };

    var getSource = function () {
      return form.dataset.klaviyoSource || 'F1 Giveaway form';
    };

    var getEventName = function () {
      return form.dataset.klaviyoEventName || 'F1 Giveaway Entry Submitted';
    };

    var getFormTag = function () {
      var formTag = getField('contact[tags]');
      return formTag ? formTag.value : 'F1_Giveaway';
    };

    var showError = function (message) {
      if (!error) {
        return;
      }

      error.textContent = message;
      error.classList.remove('hidden');
    };

    var clearError = function () {
      if (!error) {
        return;
      }

      error.textContent = '';
      error.classList.add('hidden');
    };

    var validateEmailMatch = function () {
      if (confirmEmail.value && email.value !== confirmEmail.value) {
        confirmEmail.setCustomValidity(emailMismatchMessage);
      } else {
        confirmEmail.setCustomValidity('');
      }
    };

    var buildProperties = function () {
      var firstName = getField('contact[first_name]');
      var ageConfirmed = getField('contact[age_confirmed]');
      var marketingConsent = getField('contact[marketing_consent]');

      return {
        'First name': firstName.value,
        Email: email.value,
        'Age, terms and privacy confirmed': ageConfirmed.checked,
        'Marketing consent': marketingConsent.checked,
        'Entry source': getSource(),
        'Form tag': getFormTag(),
      };
    };

    var buildEventPayload = function () {
      var firstName = getField('contact[first_name]');
      var normalizedEmail = email.value.trim().toLowerCase();

      return {
        data: {
          type: 'event',
          attributes: {
            properties: buildProperties(),
            unique_id: getFormTag() + ':' + normalizedEmail,
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: getEventName(),
                },
              },
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value,
                  first_name: firstName.value,
                  properties: buildProperties(),
                },
              },
            },
          },
        },
      };
    };

    var buildSubscriptionPayload = function () {
      var firstName = getField('contact[first_name]');

      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: getSource(),
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value,
                  first_name: firstName.value,
                  properties: buildProperties(),
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: form.dataset.klaviyoListId,
              },
            },
          },
        },
      };
    };

    var postToKlaviyo = function (endpoint, payload) {
      return fetch(
        'https://a.klaviyo.com/client/' +
          endpoint +
          '?company_id=' +
          encodeURIComponent(form.dataset.klaviyoPublicApiKey),
        {
          method: 'POST',
          headers: {
            revision: revision,
            'Content-Type': 'application/vnd.api+json',
          },
          body: JSON.stringify(payload),
        },
      ).then(function (response) {
        if (!response.ok) {
          throw new Error('Klaviyo request failed with status ' + response.status);
        }
      });
    };

    var showSuccess = function () {
      form.classList.add('hidden');

      if (intro) {
        intro.classList.add('hidden');
      }

      if (success) {
        success.classList.remove('hidden');
        success.scrollIntoView({ block: 'center' });
      }
    };

    if (!email || !confirmEmail) {
      return;
    }

    email.addEventListener('input', validateEmailMatch);
    confirmEmail.addEventListener('input', validateEmailMatch);

    form.addEventListener('submit', function (event) {
      var marketingConsent = getField('contact[marketing_consent]');
      var submission;

      event.preventDefault();
      validateEmailMatch();
      clearError();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!form.dataset.klaviyoPublicApiKey || !form.dataset.klaviyoListId) {
        showError(submitErrorMessage);
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      submission = postToKlaviyo('events', buildEventPayload());

      if (marketingConsent && marketingConsent.checked) {
        submission = submission.then(function () {
          return postToKlaviyo('subscriptions', buildSubscriptionPayload());
        });
      }

      submission
        .then(showSuccess)
        .catch(function () {
          showError(submitErrorMessage);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["f1-run-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-f1-run-form]').forEach(function (container) {
    if (container.dataset.f1RunFormInitialized === 'true') {
      return;
    }

    container.dataset.f1RunFormInitialized = 'true';

    var form = container.closest('form');

    if (!form) {
      return;
    }

    var email = form.querySelector('[data-f1-run-email]');
    var confirmEmail = form.querySelector('[data-f1-run-confirm-email]');

    if (!email || !confirmEmail) {
      return;
    }

    var emailMismatchMessage = container.dataset.emailMismatchMessage || 'Email addresses must match.';

    var validateEmailMatch = function () {
      if (confirmEmail.value && email.value !== confirmEmail.value) {
        confirmEmail.setCustomValidity(emailMismatchMessage);
      } else {
        confirmEmail.setCustomValidity('');
      }
    };

    email.addEventListener('input', validateEmailMatch);
    confirmEmail.addEventListener('input', validateEmailMatch);
    form.addEventListener('submit', validateEmailMatch);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["f1-run-klaviyo-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-f1-run-klaviyo-form]').forEach(function (form) {
    if (form.dataset.f1RunKlaviyoFormInitialized === 'true') {
      return;
    }

    form.dataset.f1RunKlaviyoFormInitialized = 'true';

    var leadBookerEmail = form.querySelector('[data-f1-run-klaviyo-email]');
    var confirmLeadBookerEmail = form.querySelector('[data-f1-run-klaviyo-confirm-email]');
    var personalEmail = form.querySelector('[data-f1-run-klaviyo-personal-email]');
    var confirmPersonalEmail = form.querySelector('[data-f1-run-klaviyo-confirm-personal-email]');
    var submitButton = form.querySelector('[data-f1-run-klaviyo-submit]');
    var error = form.querySelector('[data-f1-run-klaviyo-error]');
    var intro = form.parentElement.querySelector('[data-f1-run-klaviyo-intro]');
    var success = form.parentElement.querySelector('[data-f1-run-klaviyo-success]');
    var emailMismatchMessage = form.dataset.emailMismatchMessage || 'Email addresses must match.';
    var submitErrorMessage = form.dataset.submitErrorMessage || 'Something went wrong. Please try again.';

    var getField = function (name) {
      return form.querySelector('[name="' + name + '"]');
    };

    var showError = function (message) {
      if (!error) {
        return;
      }

      error.textContent = message;
      error.classList.remove('hidden');
    };

    var clearError = function () {
      if (!error) {
        return;
      }

      error.textContent = '';
      error.classList.add('hidden');
    };

    var validateEmailMatch = function (emailField, confirmEmailField) {
      if (confirmEmailField.value && emailField.value !== confirmEmailField.value) {
        confirmEmailField.setCustomValidity(emailMismatchMessage);
      } else {
        confirmEmailField.setCustomValidity('');
      }
    };

    var buildPayload = function () {
      var firstName = getField('contact[first_name]');
      var lastName = getField('contact[last_name]');
      var estimatedTime = getField('contact[note][Estimated 5.8km time]');
      var campsite = getField('contact[note][Campsite]');
      var ageConfirmed = getField('contact[age_confirmed]');
      var termsAccepted = getField('contact[terms_accepted]');

      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.klaviyoSource || 'F1-2 Run the Circuit form',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: personalEmail.value,
                  first_name: firstName.value,
                  last_name: lastName.value,
                  properties: {
                    'Lead booker email address': leadBookerEmail.value,
                    'Estimated 5.8km time': estimatedTime.value,
                    Campsite: campsite.value,
                    'Age confirmed': ageConfirmed.checked,
                    'Terms accepted': termsAccepted.checked,
                    'Entry source': form.dataset.klaviyoSource || 'F1-2 Run the Circuit form',
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: form.dataset.klaviyoListId,
              },
            },
          },
        },
      };
    };

    var showSuccess = function () {
      form.classList.add('hidden');

      if (intro) {
        intro.classList.add('hidden');
      }

      if (success) {
        success.classList.remove('hidden');
        success.scrollIntoView({ block: 'center' });
      }
    };

    if (!leadBookerEmail || !confirmLeadBookerEmail || !personalEmail || !confirmPersonalEmail) {
      return;
    }

    leadBookerEmail.addEventListener('input', function () {
      validateEmailMatch(leadBookerEmail, confirmLeadBookerEmail);
    });
    confirmLeadBookerEmail.addEventListener('input', function () {
      validateEmailMatch(leadBookerEmail, confirmLeadBookerEmail);
    });
    personalEmail.addEventListener('input', function () {
      validateEmailMatch(personalEmail, confirmPersonalEmail);
    });
    confirmPersonalEmail.addEventListener('input', function () {
      validateEmailMatch(personalEmail, confirmPersonalEmail);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      validateEmailMatch(leadBookerEmail, confirmLeadBookerEmail);
      validateEmailMatch(personalEmail, confirmPersonalEmail);
      clearError();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!form.dataset.klaviyoPublicApiKey || !form.dataset.klaviyoListId) {
        showError(submitErrorMessage);
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      fetch(
        'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.dataset.klaviyoPublicApiKey),
        {
          method: 'POST',
          headers: {
            revision: '2026-04-15',
            'Content-Type': 'application/vnd.api+json',
          },
          body: JSON.stringify(buildPayload()),
        },
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Klaviyo subscription failed with status ' + response.status);
          }

          showSuccess();
        })
        .catch(function () {
          showError(submitErrorMessage);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-topics"] && !Shopify.designMode) return;
  try {
    const CONFIG = {
    SCROLL_DEBOUNCE: 80,
    POSITION_TOLERANCE: 6,
    INTERSECTION_THRESHOLD: [0.15, 0.4, 0.75],
    SCROLL_MARGIN_BOTTOM: '-40%',
    DEFAULT_HEADER_OFFSET: 60,
    SCROLL_TIMEOUT: 1000,
  };

  class FAQTopicsManager {
    constructor(rootElement) {
      this.rootEl = rootElement;
      this.blockId = rootElement.id;
      this.topicsNav = rootElement.querySelector(`[data-topics-nav="${this.blockId}"]`);
      if (!this.topicsNav) {
        return;
      }

      this.contentContainer = rootElement.querySelector(`[data-topics-content="${this.blockId}"]`);
      if (!this.contentContainer) {
        return;
      }

      this.clickTargetId = null;
      this.scrollCheckTimeout = null;
      this.scrollTimeout = null;
      this.topicButtons = [];
      this.headerOffset = 0;
      this.observer = null;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);

      this.init();
    }

    init() {
      this.calculateHeaderOffset();
      this.buildNavigation();
      this.setupEventListeners();
      this.setupIntersectionObserver();
    }

    get isMobile() {
      const mobileBreakpoint = 768;
      return window.innerWidth < mobileBreakpoint;
    }

    calculateHeaderOffset() {
      const header = document.querySelector('header');
      if (!header) {
        return CONFIG.DEFAULT_HEADER_OFFSET;
      }

      const bounding = header.getBoundingClientRect();
      this.headerOffset = bounding.height;
    }

    buildNavigation() {
      const fragment = document.createDocumentFragment();
      const topicSections = this.contentContainer.querySelectorAll('[id^="faq-topic-"]');

      topicSections.forEach((section) => {
        const topics = section.querySelectorAll('[data-faq-topic]');
        topics.forEach((topicEl, idx) => {
          if (!topicEl.id) {
            topicEl.id = `${section.id}-item-${idx + 1}`;
          }

          const button = this.createTopicButton(topicEl);
          fragment.appendChild(button);
        });
      });

      this.topicsNav.appendChild(fragment);
      this.topicButtons = Array.from(this.topicsNav.querySelectorAll('[data-topic-nav]'));
      this.styleFirstAndLastButtons();
    }

    createTopicButton(topicEl) {
      const button = document.createElement('button');
      const topicText = topicEl.textContent.trim();

      button.className =
        'topic-nav-item cursor-pointer w-full text-left p-4 bg-white border border-stroke-darker text-16 text-black md:text-light-grey';
      button.setAttribute('data-topic-nav', '');
      button.setAttribute('data-target', topicEl.id);
      button.setAttribute('type', 'button');
      button.setAttribute('aria-label', `Navigate to ${topicText}`);
      button.textContent = topicText;

      return button;
    }

    styleFirstAndLastButtons() {
      if (this.topicButtons.length === 0) {
        return;
      }

      const firstButton = this.topicButtons[0];
      const lastButton = this.topicButtons[this.topicButtons.length - 1];

      firstButton.classList.add('first-topic', 'active');
      lastButton.classList.add('last-topic');
    }

    setupEventListeners() {
      this.topicsNav.addEventListener('click', (event) => {
        const button = event.target.closest('[data-topic-nav]');
        if (button) {
          this.handleTopicClick(button);
        }
      });

      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    handleTopicClick(button) {
      const targetId = button.getAttribute('data-target');
      const targetEl = document.getElementById(targetId);

      if (!targetEl) {
        return;
      }

      this.clickTargetId = targetId;
      this.setActiveButton(button);

      targetEl.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        if (!this.clickTargetId) {
          return;
        }

        this.clickTargetId = null;
      }, CONFIG.SCROLL_TIMEOUT);
    }

    handleScroll() {
      if (!this.clickTargetId) {
        return;
      }

      const targetEl = document.getElementById(this.clickTargetId);
      if (!targetEl) {
        return;
      }

      const rectTop = targetEl.getBoundingClientRect().top;
      const delta = Math.abs(rectTop - this.headerOffset);

      if (delta > CONFIG.POSITION_TOLERANCE) {
        return;
      }

      this.finalizeClickScroll();
    }

    finalizeClickScroll() {
      if (this.scrollCheckTimeout) {
        clearTimeout(this.scrollCheckTimeout);
      }

      this.scrollCheckTimeout = setTimeout(() => {
        this.setActiveButtonForId(this.clickTargetId);
        this.clickTargetId = null;
      }, CONFIG.SCROLL_DEBOUNCE);
    }

    setupIntersectionObserver() {
      if (this.isMobile) {
        return;
      }

      if (!('IntersectionObserver' in window)) {
        return;
      }

      const observedTargets = this.topicButtons.reduce((acc, button) => {
        const id = button.getAttribute('data-target');
        if (!id) {
          return acc;
        }

        const targetEl = document.getElementById(id);
        if (targetEl) {
          acc.push(targetEl);
        }

        return acc;
      }, []);
      if (observedTargets.length === 0) {
        return;
      }

      const observerOptions = {
        root: null,
        rootMargin: `-${this.headerOffset}px 0px ${CONFIG.SCROLL_MARGIN_BOTTOM} 0px`,
        threshold: [0.1, 0.3, 0.5, 0.7, 0.9],
      };

      this.observer = new IntersectionObserver(this.handleIntersection, observerOptions);
      observedTargets.forEach((target) => this.observer.observe(target));
    }

    handleIntersection(entries) {
      if (this.clickTargetId) {
        return;
      }

      const mostVisibleEntry = this.getMostVisibleEntry(entries);
      if (mostVisibleEntry) {
        this.setActiveButtonForId(mostVisibleEntry.target.id);
        return;
      }

      this.fallbackToClosest();
    }

    getMostVisibleEntry(entries) {
      return entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
    }

    fallbackToClosest() {
      const allTopicElements = this.topicButtons
        .map((button) => {
          const targetId = button.getAttribute('data-target');
          return document.getElementById(targetId);
        })
        .filter(Boolean);

      if (allTopicElements.length === 0) {
        return;
      }

      const viewportTop = this.headerOffset;
      let closestTopic = null;
      let closestDistance = Infinity;

      allTopicElements.forEach((topicEl) => {
        const rect = topicEl.getBoundingClientRect();
        const distanceFromTop = rect.top - viewportTop;

        if (distanceFromTop >= 0 && distanceFromTop < closestDistance) {
          closestDistance = distanceFromTop;
          closestTopic = topicEl;
        }
      });

      if (!closestTopic) {
        let lastTopicAbove = null;
        let maxDistanceAbove = -Infinity;

        allTopicElements.forEach((topicEl) => {
          const rect = topicEl.getBoundingClientRect();
          const distanceFromTop = rect.top - viewportTop;

          if (distanceFromTop < 0 && distanceFromTop > maxDistanceAbove) {
            maxDistanceAbove = distanceFromTop;
            lastTopicAbove = topicEl;
          }
        });

        closestTopic = lastTopicAbove || allTopicElements[0];
      }

      if (closestTopic) {
        this.setActiveButtonForId(closestTopic.id);
      }
    }

    setActiveButtonForId(targetId) {
      this.topicButtons.forEach((button) => {
        if (button.getAttribute('data-target') === targetId) {
          button.classList.add('active');
        } else {
          button.classList.remove('active');
        }
      });
    }

    setActiveButton(activeButton) {
      this.topicButtons.forEach((button) => {
        button.classList.toggle('active', button === activeButton);
      });
    }
  }

  function initializeFAQTopics() {
    const rootElement = document.querySelector('[data-faq-topics]');
    if (!rootElement) {
      return;
    }

    new FAQTopicsManager(rootElement);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFAQTopics);
  } else {
    initializeFAQTopics();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initGallery(gallery) {
      if (!gallery || gallery.dataset.galleryInitialized === 'true') return;
      gallery.dataset.galleryInitialized = 'true';

      var lightbox = gallery.querySelector('[data-gallery-lightbox]');
      var swiperElement = gallery.querySelector('[data-gallery-swiper]');
      var closeButton = gallery.querySelector('[data-gallery-close]');
      var prevButton = gallery.querySelector('[data-gallery-prev]');
      var nextButton = gallery.querySelector('[data-gallery-next]');
      var triggers = gallery.querySelectorAll('[data-gallery-trigger]');
      var slides = null;
      var preloadedImages = {};
      var swiper = null;

      if (!lightbox || !swiperElement || !triggers.length) return;

      slides = swiperElement.querySelectorAll('.shopify-files-gallery__slide');

      function preloadImage(index) {
        if (navigator.connection && navigator.connection.saveData) return;

        var slide = slides[index];
        if (!slide) return;

        var image = slide.querySelector('.shopify-files-gallery__lightbox-image');
        var src = image && (image.currentSrc || image.getAttribute('src'));
        if (!src || preloadedImages[src]) return;

        preloadedImages[src] = true;

        var preload = new Image();
        preload.decoding = 'async';
        preload.src = src;
      }

      function preloadAround(index) {
        preloadImage(index);
        preloadImage(index + 1);
        preloadImage(index - 1);
      }

      function createSwiper() {
        if (swiper || typeof Swiper === 'undefined') return;

        swiper = new Swiper(swiperElement, {
          slidesPerView: 1,
          spaceBetween: 24,
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
          },
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
        });

        swiper.on('slideChange', function () {
          preloadAround(swiper.activeIndex);
        });
      }

      function openLightbox(index) {
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
        createSwiper();

        if (swiper) {
          swiper.slideTo(index, 0);
          swiper.update();
        }

        preloadAround(index);

        if (closeButton) {
          closeButton.focus();
        }
      }

      function closeLightbox() {
        lightbox.hidden = true;
        document.body.style.overflow = '';
      }

      triggers.forEach(function (trigger) {
        var index = parseInt(trigger.getAttribute('data-gallery-index'), 10) || 0;

        trigger.addEventListener('mouseenter', function () {
          preloadImage(index);
        });

        trigger.addEventListener('focus', function () {
          preloadImage(index);
        });

        trigger.addEventListener('click', function () {
          openLightbox(index);
        });
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeLightbox);
      }

      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) {
          closeLightbox();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !lightbox.hidden) {
          closeLightbox();
        }
      });
    }

    function initGalleries() {
      document.querySelectorAll('[data-gallery-block]').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGalleries);
    } else {
      initGalleries();
    }

    document.addEventListener('shopify:section:load', initGalleries);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["giveaway-klaviyo-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-giveaway-klaviyo-form]').forEach(function (form) {
    if (form.dataset.giveawayKlaviyoFormInitialized === 'true') {
      return;
    }

    form.dataset.giveawayKlaviyoFormInitialized = 'true';

    var email = form.querySelector('[data-giveaway-klaviyo-email]');
    var confirmEmail = form.querySelector('[data-giveaway-klaviyo-confirm-email]');
    var submitButton = form.querySelector('[data-giveaway-klaviyo-submit]');
    var error = form.querySelector('[data-giveaway-klaviyo-error]');
    var intro = form.parentElement.querySelector('[data-giveaway-klaviyo-intro]');
    var success = form.parentElement.querySelector('[data-giveaway-klaviyo-success]');
    var emailMismatchMessage = form.dataset.emailMismatchMessage || 'Email addresses must match.';
    var submitErrorMessage = form.dataset.submitErrorMessage || 'Something went wrong. Please try again.';
    var revision = '2026-04-15';

    var getField = function (name) {
      return form.querySelector('[name="' + name + '"]');
    };

    var getSource = function () {
      return form.dataset.klaviyoSource || 'Giveaway Klaviyo form';
    };

    var getEventName = function () {
      return form.dataset.klaviyoEventName || 'Giveaway Entry Submitted';
    };

    var getFormTag = function () {
      var formTag = getField('contact[tags]');
      return formTag ? formTag.value : 'Giveaway_Klaviyo';
    };

    var showError = function (message) {
      if (!error) {
        return;
      }

      error.textContent = message;
      error.classList.remove('hidden');
    };

    var clearError = function () {
      if (!error) {
        return;
      }

      error.textContent = '';
      error.classList.add('hidden');
    };

    var validateEmailMatch = function () {
      if (confirmEmail.value && email.value !== confirmEmail.value) {
        confirmEmail.setCustomValidity(emailMismatchMessage);
      } else {
        confirmEmail.setCustomValidity('');
      }
    };

    var buildProperties = function () {
      var firstName = getField('contact[first_name]');
      var marketingConsent = getField('contact[marketing_consent]');
      var termsAccepted = getField('contact[terms_accepted]');

      return {
        'First name': firstName.value,
        Email: email.value,
        'Marketing consent': marketingConsent.checked,
        'Terms and privacy confirmed': termsAccepted.checked,
        'Entry source': getSource(),
        'Form tag': getFormTag(),
      };
    };

    var buildEventPayload = function () {
      var firstName = getField('contact[first_name]');
      var normalizedEmail = email.value.trim().toLowerCase();

      return {
        data: {
          type: 'event',
          attributes: {
            properties: buildProperties(),
            unique_id: getFormTag() + ':' + normalizedEmail,
            metric: {
              data: {
                type: 'metric',
                attributes: {
                  name: getEventName(),
                },
              },
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value,
                  first_name: firstName.value,
                  properties: buildProperties(),
                },
              },
            },
          },
        },
      };
    };

    var buildSubscriptionPayload = function () {
      var firstName = getField('contact[first_name]');

      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: getSource(),
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email.value,
                  first_name: firstName.value,
                  properties: buildProperties(),
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: form.dataset.klaviyoListId,
              },
            },
          },
        },
      };
    };

    var postToKlaviyo = function (endpoint, payload) {
      return fetch(
        'https://a.klaviyo.com/client/' +
          endpoint +
          '?company_id=' +
          encodeURIComponent(form.dataset.klaviyoPublicApiKey),
        {
          method: 'POST',
          headers: {
            revision: revision,
            'Content-Type': 'application/vnd.api+json',
          },
          body: JSON.stringify(payload),
        },
      ).then(function (response) {
        if (!response.ok) {
          throw new Error('Klaviyo request failed with status ' + response.status);
        }
      });
    };

    var showSuccess = function () {
      form.classList.add('hidden');

      if (intro) {
        intro.classList.add('hidden');
      }

      if (success) {
        success.classList.remove('hidden');
        success.scrollIntoView({ block: 'center' });
      }
    };

    if (!email || !confirmEmail) {
      return;
    }

    email.addEventListener('input', validateEmailMatch);
    confirmEmail.addEventListener('input', validateEmailMatch);

    form.addEventListener('submit', function (event) {
      var marketingConsent = getField('contact[marketing_consent]');
      var submission;

      event.preventDefault();
      validateEmailMatch();
      clearError();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!form.dataset.klaviyoPublicApiKey || !form.dataset.klaviyoListId) {
        showError(submitErrorMessage);
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      submission = postToKlaviyo('events', buildEventPayload());

      if (marketingConsent && marketingConsent.checked) {
        submission = submission.then(function () {
          return postToKlaviyo('subscriptions', buildSubscriptionPayload());
        });
      }

      submission
        .then(showSuccess)
        .catch(function () {
          showError(submitErrorMessage);
        })
        .finally(function () {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hero-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hero-carousel')) {
    customElements.define(
      'hero-carousel',
      class HeroCarousel extends HTMLElement {
        constructor() {
          super();

          this.swiper = null;
          this.slideIds = [];
          this.retryCount = 0;
          this.retryTimer = null;
          this.handleBlockSelect = this.handleBlockSelect.bind(this);
        }

        connectedCallback() {
          this.retryCount = 0;
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          this.initialize();
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          window.clearTimeout(this.retryTimer);
          this.retryTimer = null;
          this.destroySwiper();
        }

        initialize() {
          if (!this.isConnected || this.swiper) return;

          const container = this.querySelector('[data-hero-carousel-swiper]');
          const wrapper = container?.querySelector('.swiper-wrapper');
          const slides = wrapper
            ? Array.from(wrapper.children).filter((child) => child.matches('[data-hero-carousel-slide]'))
            : [];

          this.slideIds = slides.map((slide) => slide.dataset.heroCarouselSlideId);

          if (!container || slides.length < 2) {
            this.setControlsEnabled(false);
            return;
          }

          const SwiperConstructor = window.Swiper;
          if (typeof SwiperConstructor !== 'function') {
            if (this.retryCount < 100) {
              this.retryCount += 1;
              this.retryTimer = window.setTimeout(() => this.initialize(), 50);
            }
            return;
          }

          const previousButton = this.querySelector('[data-hero-carousel-previous]');
          const nextButton = this.querySelector('[data-hero-carousel-next]');
          const pagination = this.querySelector('[data-hero-carousel-pagination]');
          const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
          const autoplayEnabled = this.dataset.heroCarouselAutoplay === 'true';
          const autoplayDelay = Number.parseInt(this.dataset.heroCarouselAutoplayDelay, 10) || 5000;
          const pauseOnHover = this.getBooleanSetting('heroCarouselPauseOnHover', true);
          const loopEnabled = this.getBooleanSetting('heroCarouselLoop', true);
          const swipeEnabled = this.getBooleanSetting('heroCarouselEnableSwipe', true);
          const showNavigation = this.getBooleanSetting('heroCarouselShowNavigation', true);
          const showPagination = this.getBooleanSetting('heroCarouselShowPagination', true);
          const transitionEffect = this.dataset.heroCarouselTransitionEffect === 'fade' ? 'fade' : 'slide';
          const transitionSpeed = Number.parseInt(this.dataset.heroCarouselTransitionSpeed, 10) || 600;

          try {
            this.setControlsEnabled(true);
            this.swiper = new SwiperConstructor(container, {
              slidesPerView: 1,
              spaceBetween: 0,
              speed: reduceMotion ? 0 : transitionSpeed,
              effect: transitionEffect,
              fadeEffect: {
                crossFade: true,
              },
              loop: loopEnabled,
              autoplay:
                autoplayEnabled && !reduceMotion
                  ? {
                      delay: autoplayDelay,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: pauseOnHover,
                    }
                  : false,
              allowTouchMove: swipeEnabled,
              simulateTouch: swipeEnabled,
              grabCursor: swipeEnabled,
              watchOverflow: true,
              keyboard: {
                enabled: true,
                onlyInViewport: true,
              },
              navigation: showNavigation
                ? {
                    prevEl: previousButton,
                    nextEl: nextButton,
                  }
                : false,
              pagination: showPagination
                ? {
                    el: pagination,
                    clickable: true,
                  }
                : false,
              a11y: {
                prevSlideMessage: 'Previous hero slide',
                nextSlideMessage: 'Next hero slide',
              },
              on: {
                afterInit: (swiper) => this.revealActiveSlide(swiper),
                slideChangeTransitionEnd: (swiper) => this.revealActiveSlide(swiper),
              },
            });
          } catch (error) {
            this.swiper = null;
            this.setControlsEnabled(false);
            console.error('HeroCarousel: failed to initialize Swiper', error);
          }
        }

        getBooleanSetting(name, fallback) {
          const value = this.dataset[name];
          return value === undefined ? fallback : value === 'true';
        }

        setControlsEnabled(enabled) {
          this.classList.toggle('hero-carousel--ready', enabled);

          this.querySelectorAll('[data-hero-carousel-control]').forEach((control) => {
            const isNavigation =
              control.hasAttribute('data-hero-carousel-previous') || control.hasAttribute('data-hero-carousel-next');
            const isPagination = control.hasAttribute('data-hero-carousel-pagination');
            const settingEnabled =
              (!isNavigation || this.getBooleanSetting('heroCarouselShowNavigation', true)) &&
              (!isPagination || this.getBooleanSetting('heroCarouselShowPagination', true));
            const controlEnabled = enabled && settingEnabled;

            control.setAttribute('aria-hidden', controlEnabled ? 'false' : 'true');

            if (control.tagName === 'BUTTON') {
              control.disabled = !controlEnabled;
            }
          });
        }

        revealActiveSlide(swiper) {
          const activeSlide = swiper.slides?.[swiper.activeIndex];
          const staggerContainer = activeSlide?.querySelector('.stagger-container');

          if (staggerContainer && typeof window.staggerAnimation?.triggerAnimation === 'function') {
            window.staggerAnimation.triggerAnimation(staggerContainer);
          }
        }

        handleBlockSelect(event) {
          if (!this.swiper || typeof event.target?.closest !== 'function') return;

          const selectedSlide = event.target.closest('[data-hero-carousel-slide]');
          if (!selectedSlide || !this.contains(selectedSlide)) return;

          const selectedId = selectedSlide.dataset.heroCarouselSlideId;
          const slideIndex = this.slideIds.indexOf(selectedId);
          if (slideIndex < 0) return;

          if (this.swiper.params?.loop && typeof this.swiper.slideToLoop === 'function') {
            this.swiper.slideToLoop(slideIndex, 0);
          } else {
            this.swiper.slideTo(slideIndex, 0);
          }
        }

        destroySwiper() {
          if (this.swiper && typeof this.swiper.destroy === 'function') {
            this.swiper.destroy(true, true);
          }

          this.swiper = null;
          this.setControlsEnabled(false);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hero-image"] && !Shopify.designMode) return;
  try {
    function updateMobileHeroPageOffset() {
    const firstHero = document.querySelector('.hero-image-frame');
    if (!firstHero) {
      return;
    }

    const heroSection = firstHero.closest('.shopify-section');
    const firstMainSection = document.querySelector('body > .shopify-section:not(.shopify-section-group-header-group)');

    if (heroSection !== firstMainSection) {
      firstHero.style.removeProperty('--hero-mobile-page-offset');
      return;
    }

    const pageOffset = Math.max(0, firstHero.getBoundingClientRect().top + window.scrollY);
    firstHero.style.setProperty('--hero-mobile-page-offset', `${pageOffset}px`);
  }

  function initMobileHeroPageOffset() {
    updateMobileHeroPageOffset();

    window.addEventListener('resize', updateMobileHeroPageOffset, { passive: true });
    window.visualViewport?.addEventListener('resize', updateMobileHeroPageOffset, { passive: true });

    if ('ResizeObserver' in window) {
      const headerObserver = new ResizeObserver(updateMobileHeroPageOffset);
      document
        .querySelectorAll('body > .shopify-section-group-header-group')
        .forEach((section) => headerObserver.observe(section));
    }

    document.fonts?.ready.then(updateMobileHeroPageOffset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileHeroPageOffset);
  } else {
    initMobileHeroPageOffset();
  }

  document.addEventListener('shopify:section:load', updateMobileHeroPageOffset);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hydration-credits"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const creditsEl = document.querySelector('[data-hydration-credits]');
    if (!creditsEl) return;

    const percentage = parseInt(creditsEl.dataset.creditsPercentage) || 10;
    const pointsSpan = creditsEl.querySelector('[data-hydration-credits-points]');
    const worthSpan = creditsEl.querySelector('[data-hydration-credits-worth]');

    function updateCredits() {
      const checked = document.querySelector('[data-bundle-switch]:checked');
      if (!checked) return;

      const canSubscribe = checked.dataset.canSubscribe === 'true';
      if (!canSubscribe) {
        creditsEl.classList.add('hidden');
        return;
      }

      const priceInCents = parseInt(checked.dataset.subscriptionPrice) || 0;
      const credits = Math.round((priceInCents * percentage) / 100);
      const worthPounds = (credits / 100).toFixed(2);

      pointsSpan.textContent = '+' + credits + ' Hydration Credits';
      worthSpan.textContent = '(worth £' + worthPounds + ')';
      creditsEl.classList.remove('hidden');
    }

    updateCredits();

    document.querySelectorAll('[data-bundle-switch]').forEach((radio) => {
      radio.addEventListener('change', updateCredits);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["loyalty-credits"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    if (typeof LoyaltyPage === 'undefined') return;
    LoyaltyPage.onReady(function(data) {
      var card = document.querySelector('[data-loyalty-credits-card]');
      if (!card) return;

      function renderBalance() {
        var currentData = LoyaltyPage.getData() || data;
        var balance = currentData.account.balance;
        var rate = currentData.program.redemptionRate;
        var value = balance * rate;

        card.querySelector('[data-loyalty-credits-amount]').textContent = LoyaltyPage.formatCredits(balance) + ' ';
        card.querySelector('[data-loyalty-credits-value]').textContent = LoyaltyPage.formatCurrency(value);
      }

      renderBalance();
      document.addEventListener('loyalty:balance-updated', renderBalance);

      card.querySelector('[data-loyalty-skeleton]').classList.add('hidden');
      card.querySelector('[data-loyalty-content]').classList.remove('hidden');

      var historyBtn = card.querySelector('[data-loyalty-view-history]');
      if (historyBtn) {
        historyBtn.addEventListener('click', function() {
          var target = document.querySelector('[data-loyalty-history-card]');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      var redeemBtn = card.querySelector('[data-loyalty-redeem-discount]');
      if (redeemBtn) {
        var contracts = data.subscriptionContracts || [];
        var minimum = (data.program && data.program.minimumCreditsToRedeemDiscount) || 0;
        var initialBalance = data.account ? data.account.balance : 0;

        function disableRedeem(reason) {
          redeemBtn.disabled = true;
          redeemBtn.title = reason;
          redeemBtn.style.opacity = '0.5';
          redeemBtn.style.cursor = 'not-allowed';
        }

        if (contracts.length === 0) {
          disableRedeem('No active subscription');
        } else if (initialBalance < minimum) {
          disableRedeem('Need ' + LoyaltyPage.formatCredits(minimum - initialBalance) + ' more credits to redeem a discount');
        } else {
          redeemBtn.addEventListener('click', function() {
            var currentBalance = LoyaltyPage.getData().account.balance;
            var discountValue = currentBalance * data.program.redemptionRate;

            if (!confirm('Redeem ' + LoyaltyPage.formatCredits(currentBalance) + ' credits for a ' + LoyaltyPage.formatCurrency(discountValue) + ' discount on your next order?')) return;

            var btnText = redeemBtn.querySelector('span.relative');
            var originalText = btnText.textContent;
            btnText.textContent = 'Redeeming...';
            redeemBtn.style.pointerEvents = 'none';
            redeemBtn.style.opacity = '0.6';

            LoyaltyPage.redeemDiscount(currentBalance)
              .then(function() {
                btnText.textContent = 'Redeemed!';
                redeemBtn.style.opacity = '1';
                setTimeout(function() {
                  window.location.reload();
                }, 1000);
              })
              .catch(function(err) {
                alert('Failed to redeem: ' + err.message);
                btnText.textContent = originalText;
                redeemBtn.style.pointerEvents = '';
                redeemBtn.style.opacity = '1';
              });
          });
        }
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["loyalty-earn"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (typeof LoyaltyPage === 'undefined') return;

    var grid = document.querySelector('[data-loyalty-earn-grid]');
    if (!grid) return;

    function gridItemFor(card) {
      var node = card;
      while (node && node.parentElement && node.parentElement !== grid) {
        node = node.parentElement;
      }
      return node && node.parentElement === grid ? node : null;
    }

    function hasEvent(events, eventType) {
      return events.indexOf(eventType) !== -1;
    }

    function setPendingState(card, isPending) {
      var pendingBadge = card.querySelector('[data-loyalty-pending-badge]');
      var pendingMessage = card.querySelector('[data-loyalty-pending-message]');
      var description = card.querySelector('[data-loyalty-description]');
      var button = card.querySelector('[data-loyalty-social-claim]');

      if (pendingBadge) pendingBadge.classList.toggle('hidden', !isPending);
      if (pendingMessage) pendingMessage.classList.toggle('hidden', !isPending);
      if (description) description.classList.toggle('hidden', isPending);

      if (!button) return;

      var defaultText = button.getAttribute('data-loyalty-social-default-text') || button.textContent;
      if (isPending) {
        button.disabled = true;
        button.classList.add('hidden');
        button.textContent = defaultText;
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.disabled = false;
        button.classList.remove('hidden');
        button.textContent = defaultText;
        button.removeAttribute('aria-disabled');
      }
    }

    function applyEventStates(data) {
      var claimed = (data && data.claimedEvents) || [];
      var pending = (data && data.pendingApprovalEvents) || [];

      grid.querySelectorAll('[data-loyalty-event-type]').forEach(function (card) {
        var eventType = card.getAttribute('data-loyalty-event-type');
        var item = gridItemFor(card);

        if (item) item.style.display = '';
        setPendingState(card, false);

        if (hasEvent(claimed, eventType)) {
          if (item) item.style.display = 'none';
          return;
        }

        if (hasEvent(pending, eventType)) {
          setPendingState(card, true);
        }
      });
    }

    LoyaltyPage.onReady(function (data) {
      applyEventStates(data);
      grid.classList.remove('invisible');
    });

    document.addEventListener('loyalty:claimed-events-updated', function () {
      var data = LoyaltyPage.getData();
      applyEventStates(data);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["loyalty-history"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    if (typeof LoyaltyPage === 'undefined') return;
    var coinUrl = '';
    var coinEl = document.querySelector('[data-loyalty-history-coin]');
    if (coinEl) {
      coinUrl = coinEl.src;
      coinEl.remove();
    }

    // Collect icon URLs from settings
    var typeIconUrls = {};
    document.querySelectorAll('[data-loyalty-history-icon]').forEach(function(img) {
      typeIconUrls[img.dataset.loyaltyHistoryIcon] = img.src;
      img.remove();
    });

    function buildIcon(type) {
      var url = typeIconUrls[type] || typeIconUrls.EARN;
      if (url) {
        var img = document.createElement('img');
        img.src = url;
        img.width = 60;
        img.height = 60;
        img.className = 'w-[60px] h-[60px] rounded-full object-cover shrink-0';
        return img;
      }
      // Fallback: grey circle with first letter
      var placeholder = document.createElement('div');
      placeholder.className = 'w-[60px] h-[60px] rounded-full bg-stroke-darker flex items-center justify-center shrink-0';
      var letter = document.createElement('span');
      letter.className = 'text-16 font-medium text-grey';
      letter.textContent = (type || 'E').charAt(0);
      placeholder.appendChild(letter);
      return placeholder;
    }

    LoyaltyPage.onReady(function(data) {
      var card = document.querySelector('[data-loyalty-history-card]');
      if (!card) return;

      var transactions = data.recentTransactions || [];
      var list = card.querySelector('[data-loyalty-history-list]');
      var initialCount = 3;

      if (transactions.length === 0) {
        card.querySelector('[data-loyalty-skeleton]').classList.add('hidden');
        list.innerHTML = '<p class="text-14 text-grey leading-5">No transactions yet.</p>';
        card.querySelector('[data-loyalty-content]').classList.remove('hidden');
        return;
      }

      transactions.forEach(function(tx, i) {
        var row = document.createElement('div');
        row.className = 'flex items-center justify-between';
        if (i >= initialCount) row.classList.add('hidden');
        row.dataset.loyaltyHistoryRow = '';

        // Left: icon + info
        var left = document.createElement('div');
        left.className = 'flex gap-4 items-center';
        left.appendChild(buildIcon(tx.type));

        var textWrap = document.createElement('div');
        textWrap.className = 'flex flex-col gap-1';

        var desc = document.createElement('p');
        desc.className = 'text-16 font-medium text-black leading-6';
        desc.textContent = tx.description;
        textWrap.appendChild(desc);

        var date = document.createElement('p');
        date.className = 'text-14 text-grey leading-5';
        date.textContent = LoyaltyPage.formatDate(tx.createdAt, true);
        textWrap.appendChild(date);

        left.appendChild(textWrap);
        row.appendChild(left);

        // Right: credits
        var right = document.createElement('div');
        right.className = 'flex gap-1.5 items-center shrink-0';

        var coin = document.createElement('img');
        coin.src = coinUrl;
        coin.width = 20;
        coin.height = 20;
        right.appendChild(coin);

        var amount = document.createElement('p');
        amount.className = 'text-16 font-medium leading-6 whitespace-nowrap';
        if (tx.amount > 0) {
          amount.classList.add('text-orange');
          amount.textContent = '+' + LoyaltyPage.formatCredits(tx.amount);
        } else {
          amount.classList.add('text-black');
          amount.textContent = LoyaltyPage.formatCredits(tx.amount);
        }
        right.appendChild(amount);

        row.appendChild(right);
        list.appendChild(row);

        // Divider (except last)
        if (i < transactions.length - 1) {
          var divider = document.createElement('div');
          divider.className = 'h-px bg-stroke-darker w-full';
          if (i >= initialCount) divider.classList.add('hidden');
          divider.dataset.loyaltyHistoryRow = '';
          list.appendChild(divider);
        }
      });

      if (transactions.length > initialCount) {
        var moreBtn = card.querySelector('[data-loyalty-history-more]');
        moreBtn.classList.remove('hidden');
        moreBtn.addEventListener('click', function() {
          card.querySelectorAll('[data-loyalty-history-row]').forEach(function(el) {
            el.classList.remove('hidden');
          });
          moreBtn.classList.add('hidden');
        });
      }

      card.querySelector('[data-loyalty-skeleton]').classList.add('hidden');
      card.querySelector('[data-loyalty-content]').classList.remove('hidden');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["loyalty-journey"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    if (typeof LoyaltyPage === 'undefined') return;
    var iconUrls = {};
    document.querySelectorAll('[data-loyalty-icon]').forEach(function(img) {
      iconUrls[img.dataset.loyaltyIcon] = img.src;
      img.remove();
    });

    LoyaltyPage.onReady(function(data) {
      var card = document.querySelector('[data-loyalty-journey-card]');
      if (!card) return;

      var contracts = data.subscriptionContracts || [];
      if (contracts.length === 0) {
        card.style.display = 'none';
        return;
      }

      var contract = contracts[0];
      var cycles = contract.billingCycles || [];
      var transactions = data.recentTransactions || [];
      var expectedCredits = LoyaltyPage.calculateExpectedCredits(contract.price, data.program);

      // Find EARN transactions to map credits to cycles
      var earnTransactions = transactions.filter(function(t) { return t.type === 'EARN'; });

      // Determine cycle states
      var billedCount = 0;
      var firstUnbilledIndex = -1;
      cycles.forEach(function(cycle, i) {
        if (cycle.status === 'BILLED') {
          billedCount++;
        } else if (firstUnbilledIndex === -1) {
          firstUnbilledIndex = i;
        }
      });

      // Update next delivery info
      if (firstUnbilledIndex !== -1) {
        var nextCycle = cycles[firstUnbilledIndex];
        var nextInfo = card.querySelector('[data-loyalty-next-info]');
        card.querySelector('[data-loyalty-next-delivery]').textContent = 'Delivery ' + (firstUnbilledIndex + 1);
        card.querySelector('[data-loyalty-next-date]').textContent = 'Arriving ' + LoyaltyPage.formatDate(nextCycle.billingAttemptExpectedDate);
        nextInfo.classList.remove('hidden');
      }

      // Build milestone data
      var maxVisible = cycles.length;
      var milestones = [];

      for (var i = 0; i < maxVisible; i++) {
        var cycle = cycles[i];
        var isBilled = cycle.status === 'BILLED';
        var isUpcoming = i === firstUnbilledIndex;
        var isFuture = !isBilled && !isUpcoming;
        var earnTx = (isBilled && earnTransactions.length > 0) ? earnTransactions.pop() : null;
        var creditAmount = earnTx ? earnTx.amount : (isBilled ? null : expectedCredits);

        milestones.push({
          index: i,
          cycle: cycle,
          isBilled: isBilled,
          isUpcoming: isUpcoming,
          isFuture: isFuture,
          creditAmount: creditAmount
        });
      }

      function buildMilestoneEl(m) {
        var milestone = document.createElement('div');
        milestone.className = 'flex flex-col gap-4 items-center shrink-0 snap-center';

        var iconWrap = document.createElement('div');
        iconWrap.className = 'relative z-10';
        var icon = document.createElement('img');
        icon.width = 48;
        icon.height = 48;
        icon.className = 'block';
        if (m.isBilled) {
          icon.src = iconUrls.received;
        } else if (m.isUpcoming) {
          icon.src = iconUrls.upcoming;
        } else {
          icon.src = iconUrls.future;
        }
        iconWrap.appendChild(icon);
        milestone.appendChild(iconWrap);

        var info = document.createElement('div');
        info.className = 'flex flex-col gap-1 items-center';

        var title = document.createElement('p');
        title.className = 'text-16 font-medium text-black leading-6 whitespace-nowrap';
        title.textContent = 'Delivery ' + (m.index + 1);
        info.appendChild(title);

        var date = document.createElement('p');
        date.className = 'text-14 text-grey leading-5 whitespace-nowrap';
        date.textContent = LoyaltyPage.formatDate(m.cycle.billingAttemptExpectedDate);
        info.appendChild(date);

        if (typeof m.creditAmount === 'number' && m.creditAmount > 0) {
          var creditsRow = document.createElement('div');
          creditsRow.className = 'flex gap-1.5 items-center justify-center';
          var coinImg = document.createElement('img');
          coinImg.src = iconUrls.coin;
          coinImg.width = 16;
          coinImg.height = 16;
          creditsRow.appendChild(coinImg);
          var creditsText = document.createElement('p');
          creditsText.className = 'text-14 font-medium text-orange leading-5 whitespace-nowrap';
          creditsText.textContent = '+' + LoyaltyPage.formatCredits(m.creditAmount);
          creditsRow.appendChild(creditsText);
          info.appendChild(creditsRow);
        }

        milestone.appendChild(info);
        return milestone;
      }

      // Build timeline
      var timeline = card.querySelector('[data-loyalty-journey-timeline]');
      var timelineInner = card.querySelector('[data-loyalty-journey-timeline-inner]');
      milestones.forEach(function(m, i) {
        if (i > 0) {
          var line = document.createElement('div');
          line.className = 'min-w-8 flex-1 h-[2px] mt-[23px] -mx-3';
          if (m.isBilled) {
            line.classList.add('bg-orange');
          } else if (m.isUpcoming) {
            line.className = 'relative min-w-8 flex-1 h-[2px] mt-[23px] -mx-3 overflow-hidden bg-stroke-darker';
            var fill = document.createElement('div');
            fill.className = 'absolute inset-y-0 left-0 w-1/2 bg-orange';
            line.appendChild(fill);
          } else {
            line.classList.add('bg-stroke-darker');
          }
          timelineInner.appendChild(line);
        }
        timelineInner.appendChild(buildMilestoneEl(m));
      });

      // Size the inner track so max 6 visible on desktop, 4 on tablet/mobile
      var totalSteps = milestones.length;
      function sizeTimeline() {
        var isMobile = window.innerWidth < 768;
        var maxVisible = window.innerWidth >= 1024 ? 6 : isMobile ? 1 : 4;
        timelineInner.style.minWidth = totalSteps > maxVisible
          ? (totalSteps / maxVisible * 100) + '%'
          : '100%';
        var pad = isMobile ? (timeline.offsetWidth / 2) + 'px' : '';
        timelineInner.style.paddingLeft = pad;
        timelineInner.style.paddingRight = pad;
      }
      sizeTimeline();
      window.addEventListener('resize', sizeTimeline);

      // Hide skeletons, show timeline
      card.querySelectorAll('[data-loyalty-journey-skeleton]').forEach(function(el) { el.style.display = 'none'; });
      timeline.style.display = '';
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["loyalty-partner-perks"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-loyalty-partner-perks-section]').forEach(function (section) {
      var viewport = section.querySelector('[data-loyalty-partner-perks-viewport]');
      var track = section.querySelector('[data-loyalty-partner-perks-track]');
      var controls = section.querySelector('[data-loyalty-partner-perks-controls]');
      var prevButton = section.querySelector('[data-loyalty-partner-perks-prev]');
      var nextButton = section.querySelector('[data-loyalty-partner-perks-next]');
      var dialog = section.querySelector('[data-loyalty-partner-perks-dialog]');
      var dialogTitle = section.querySelector('[data-loyalty-partner-perks-dialog-title]');
      var dialogContent = section.querySelector('[data-loyalty-partner-perks-dialog-content]');
      var dialogFooter = section.querySelector('[data-loyalty-partner-perks-dialog-footer]');
      var dialogCta = section.querySelector('[data-loyalty-partner-perks-dialog-cta]');
      var dialogCtaLabel = section.querySelector('[data-loyalty-partner-perks-dialog-cta-label]');
      var closeButton = section.querySelector('[data-loyalty-partner-perks-dialog-close]');

      if (!viewport || !track) return;

      function trackEvent(eventName) {
        eventName = (eventName || '').trim();
        if (!eventName || typeof LoyaltyPage === 'undefined' || typeof LoyaltyPage.trackEvent !== 'function') {
          return;
        }
        LoyaltyPage.trackEvent(eventName).catch(function (error) {
          console.error('[LoyaltyPage] Failed to track partner perk event:', error.message);
        });
      }

      function setDialogClickEvent(eventName) {
        if (!dialogCta) return;
        eventName = (eventName || '').trim();
        if (eventName) {
          dialogCta.setAttribute('data-loyalty-partner-perk-click-event', eventName);
        } else {
          dialogCta.removeAttribute('data-loyalty-partner-perk-click-event');
        }
      }

      var slides = Array.prototype.slice.call(track.children).filter(function (item) {
        return (
          item.matches('[data-loyalty-partner-perk-card]') || item.querySelector('[data-loyalty-partner-perk-card]')
        );
      });

      if (slides.length > 3 && typeof Swiper !== 'undefined') {
        viewport.classList.add('swiper', 'loyalty-partner-perks-swiper');
        track.classList.remove('grid', 'grid-cols-1', 'lg:grid-cols-3', 'gap-6');
        track.classList.add('swiper-wrapper');
        slides.forEach(function (slide) {
          slide.classList.add('swiper-slide');
        });
        if (controls) {
          controls.classList.remove('hidden');
          controls.classList.add('flex');
        }
        new Swiper(viewport, {
          slidesPerView: 1.1,
          spaceBetween: 24,
          grabCursor: true,
          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
          },
          breakpoints: {
            1024: { slidesPerView: 2.1, spaceBetween: 24 },
            1280: { slidesPerView: 3, spaceBetween: 24 },
          },
        });
      } else if (controls) {
        controls.classList.add('hidden');
      }

      function closeDialog() {
        if (!dialog) return;
        dialog.classList.add('hidden');
        dialog.classList.remove('flex');
        document.body.style.overflow = '';
        setDialogClickEvent('');
      }

      function openDialog(card) {
        if (!dialog || !dialogTitle || !dialogContent || !card) return;
        var template = card.querySelector('[data-loyalty-partner-perk-dialog-template]');
        if (!template) return;
        dialogTitle.textContent = card.getAttribute('data-dialog-title') || '';
        dialogContent.innerHTML = template.innerHTML;
        var seenEvent = card.getAttribute('data-loyalty-partner-perk-seen-event') || '';
        var clickEvent = card.getAttribute('data-loyalty-partner-perk-click-event') || '';
        setDialogClickEvent(clickEvent);
        if (dialogFooter && dialogCta && dialogCtaLabel) {
          var claimUrl = card.getAttribute('data-claim-url') || '';
          var claimLabel = card.getAttribute('data-claim-label') || '';
          if (claimUrl && claimLabel) {
            dialogCta.href = claimUrl;
            dialogCtaLabel.textContent = claimLabel;
            dialogFooter.classList.remove('hidden');
          } else {
            dialogFooter.classList.add('hidden');
            dialogCta.href = '#';
            dialogCtaLabel.textContent = '';
          }
        }
        dialog.classList.remove('hidden');
        dialog.classList.add('flex');
        document.body.style.overflow = 'hidden';
        trackEvent(seenEvent);
      }

      section.addEventListener('click', function (event) {
        var claimButton = event.target.closest('[data-loyalty-partner-perk-claim]');
        if (claimButton && section.contains(claimButton)) {
          trackEvent(claimButton.getAttribute('data-loyalty-partner-perk-click-event'));
          return;
        }

        var trigger = event.target.closest('[data-loyalty-partner-perk-learn-more]');
        if (!trigger || !section.contains(trigger)) return;
        var card = trigger.closest('[data-loyalty-partner-perk-card]');
        if (!card && trigger.closest('.swiper-slide')) {
          card = trigger.closest('.swiper-slide').querySelector('[data-loyalty-partner-perk-card]');
        }
        openDialog(card);
      });

      if (dialog) {
        dialog.addEventListener('click', function (event) {
          if (event.target === dialog) closeDialog();
        });
      }
      if (closeButton) {
        closeButton.addEventListener('click', closeDialog);
      }
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && dialog && !dialog.classList.contains('hidden')) {
          closeDialog();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["loyalty-redeem"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    if (typeof LoyaltyPage === 'undefined') return;
    var coinUrl = '';
    var coinEl = document.querySelector('[data-loyalty-redeem-coin]');
    if (coinEl) {
      coinUrl = coinEl.src;
      coinEl.remove();
    }

    LoyaltyPage.onReady(function(data) {
      var section = document.querySelector('[data-loyalty-redeem-section]');
      if (!section) return;

      var rewards = data.rewards || [];
      var skeleton = section.querySelector('[data-loyalty-skeleton]');
      var grid = section.querySelector('[data-loyalty-redeem-grid]');

      if (rewards.length === 0) {
        skeleton.classList.add('hidden');
        return;
      }

      LoyaltyPage.getRewardDetails(rewards).then(function(nodeMap) {
        rewards.forEach(function(reward) {
          var variant = reward.variantGid ? nodeMap[reward.variantGid] : null;
          var product = nodeMap[reward.productGid] || (variant && variant.product) || {};

          // Resolve image: variant image > product featured image
          var imageUrl = '';
          var imageAlt = '';
          if (variant && variant.image && variant.image.url) {
            imageUrl = variant.image.url;
            imageAlt = variant.image.altText || '';
          } else if (product.featuredImage && product.featuredImage.url) {
            imageUrl = product.featuredImage.url;
            imageAlt = product.featuredImage.altText || '';
          }

          // Resolve title: reward title > variant title > product title
          var displayTitle = reward.title || product.title || 'Reward';
          var variantTitle = variant && variant.title && variant.title !== 'Default Title' ? variant.title : '';

          var card = document.createElement('div');
          card.className = 'bg-white border border-stroke-darker rounded-xl p-6 shadow-[0px_1px_2px_0px_rgba(11,7,7,0.05)] flex flex-col gap-4 h-full';

          // Image
          if (imageUrl) {
            var imgWrap = document.createElement('div');
            imgWrap.className = 'h-[340px] rounded-lg overflow-hidden w-full';
            var img = document.createElement('img');
            img.src = imageUrl;
            img.alt = imageAlt;
            img.className = 'w-full h-full object-cover';
            imgWrap.appendChild(img);
            card.appendChild(imgWrap);
          }

          // Info
          var info = document.createElement('div');
          info.className = 'flex flex-col gap-1 w-full';

          var row = document.createElement('div');
          row.className = 'flex items-start justify-between w-full';

          var title = document.createElement('p');
          title.className = 'text-16 font-medium text-black leading-6';
          title.textContent = displayTitle;
          row.appendChild(title);

          var creditsWrap = document.createElement('div');
          creditsWrap.className = 'flex gap-1.5 items-center shrink-0';
          var coinImg = document.createElement('img');
          coinImg.src = coinUrl;
          coinImg.width = 20;
          coinImg.height = 20;
          creditsWrap.appendChild(coinImg);

          var creditsAmount = document.createElement('span');
          creditsAmount.className = 'text-16 font-medium text-black leading-6 whitespace-nowrap';
          creditsAmount.textContent = LoyaltyPage.formatCredits(reward.creditCost);
          creditsWrap.appendChild(creditsAmount);

          var creditsValue = document.createElement('span');
          creditsValue.className = 'text-14 font-medium text-orange leading-5 whitespace-nowrap';
          creditsValue.textContent = '(' + LoyaltyPage.formatCurrency(reward.creditCost * data.program.redemptionRate) + ')';
          creditsWrap.appendChild(creditsValue);

          row.appendChild(creditsWrap);
          info.appendChild(row);

          // Variant subtitle
          if (variantTitle) {
            var subtitle = document.createElement('p');
            subtitle.className = 'text-14 text-grey leading-5';
            subtitle.textContent = variantTitle;
            info.appendChild(subtitle);
          }

          card.appendChild(info);

          // Redeem button
          var btn = document.createElement('button');
          btn.className = 'relative overflow-clip px-[14px] py-[10px] rounded-lg shadow-[0px_1px_2px_0px_rgba(11,7,7,0.05)] border-2 border-[rgba(255,255,255,0.12)] text-14 font-medium text-white leading-5 w-full text-center mt-auto';
          btn.dataset.loyaltyRewardId = reward.id;
          btn.dataset.loyaltyProductGid = reward.productGid;
          btn.dataset.loyaltyVariantGid = reward.variantGid || '';

          var btnBg = document.createElement('div');
          btnBg.className = 'absolute inset-0 bg-orange rounded-lg pointer-events-none';
          btnBg.setAttribute('aria-hidden', 'true');
          btn.appendChild(btnBg);

          var btnText = document.createElement('span');
          btnText.className = 'relative';
          btnText.textContent = 'Redeem';
          btn.appendChild(btnText);

          var btnShadow = document.createElement('div');
          btnShadow.className = 'absolute inset-0 pointer-events-none rounded-[inherit] shadow-[inset_0px_0px_0px_1px_rgba(11,7,7,0.08),inset_0px_-2px_0px_0px_rgba(11,7,7,0.05)]';
          btn.appendChild(btnShadow);

          card.appendChild(btn);

          var slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.appendChild(card);
          grid.appendChild(slide);
        });

        skeleton.classList.add('hidden');
        var carouselWrap = section.querySelector('[data-loyalty-redeem-carousel]');
        carouselWrap.classList.remove('hidden');
        var swiperEl = section.querySelector('[data-loyalty-redeem-swiper]');

        // Show arrows only if more than 3 rewards
        var prevBtn = section.querySelector('[data-loyalty-redeem-prev]');
        var nextBtn = section.querySelector('[data-loyalty-redeem-next]');
        if (rewards.length <= 3) {
          prevBtn.parentElement.classList.add('hidden');
        }

        // Init Swiper
        var swiper = new Swiper(swiperEl, {
          slidesPerView: 1.1,
          spaceBetween: 24,
          grabCursor: true,
          navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn
          },
          breakpoints: {
            1024: { slidesPerView: 2.1, spaceBetween: 24 },
            1280: { slidesPerView: 3, spaceBetween: 24 }
          }
        });

        // Redeem button click handlers
        grid.addEventListener('click', function(e) {
          var btn = e.target.closest('[data-loyalty-reward-id]');
          if (!btn) return;

          var rewardId = btn.dataset.loyaltyRewardId;
          var variantGid = btn.dataset.loyaltyVariantGid;

          if (!variantGid) {
            alert('No variant selected for this reward.');
            return;
          }

          // Confirm
          var reward = rewards.find(function(r) { return String(r.id) === String(rewardId); });
          var cost = reward ? reward.creditCost : 0;
          var balance = LoyaltyPage.getData().account.balance;

          if (balance < cost) {
            alert('Insufficient credits. You need ' + LoyaltyPage.formatCredits(cost) + ' credits but have ' + LoyaltyPage.formatCredits(balance) + '.');
            return;
          }

          if (!confirm('Redeem ' + LoyaltyPage.formatCredits(cost) + ' credits for this reward?')) return;

          // Disable button
          var btnText = btn.querySelector('span.relative');
          var originalText = btnText.textContent;
          btnText.textContent = 'Redeeming...';
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.6';

          LoyaltyPage.redeemReward(rewardId, variantGid)
            .then(function(result) {
              btnText.textContent = 'Redeemed!';
              btn.style.opacity = '1';

              setTimeout(function() {
                window.location.reload();
              }, 1000);
            })
            .catch(function(err) {
              alert('Failed to redeem: ' + err.message);
              btnText.textContent = originalText;
              btn.style.pointerEvents = '';
              btn.style.opacity = '1';
            });
        });
      }).catch(function() {
        skeleton.classList.add('hidden');
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["loyalty-subscription"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    if (typeof LoyaltyPage === 'undefined') return;
    LoyaltyPage.onReady(function(data) {
      var card = document.querySelector('[data-loyalty-subscription-card]');
      if (!card) return;

      var contracts = data.subscriptionContracts || [];
      var typeEl = card.querySelector('[data-loyalty-sub-type]');
      var statusEl = card.querySelector('[data-loyalty-sub-status]');

      if (contracts.length === 0) {
        typeEl.textContent = 'No subscription';
        statusEl.textContent = 'None';
        var manageBtn = card.querySelector('[data-loyalty-manage-btn]');
        if (manageBtn) manageBtn.classList.add('hidden');
      } else {
        var contract = contracts[0];
        typeEl.textContent = contract.sellingPlanName || 'Subscription';

        var status = contract.status;
        statusEl.textContent = status.charAt(0) + status.slice(1).toLowerCase();
        var manageLink = card.querySelector('[data-loyalty-manage-btn] a');
        if (manageLink) manageLink.href = 'https://account.gatorade.co.uk/pages/7c4a25d5-0da8-4259-bf5f-40ed6112e4d6';

        statusEl.classList.remove('bg-light-grey', 'bg-green', 'bg-orange', 'bg-red');
        if (status === 'ACTIVE') {
          statusEl.classList.add('bg-green');
        } else if (status === 'PAUSED') {
          statusEl.classList.add('bg-orange');
        } else {
          statusEl.classList.add('bg-red');
        }
      }

      if (contracts.length > 1) {
        var nav = card.querySelector('[data-loyalty-sub-nav]');
        if (nav) nav.classList.remove('hidden');
      }

      card.querySelectorAll('[data-loyalty-skeleton]').forEach(function(el) { el.classList.add('hidden'); });
      card.querySelectorAll('[data-loyalty-content]').forEach(function(el) { el.classList.remove('hidden'); });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["people-item"] && !Shopify.designMode) return;
  try {
    class PeopleVideoControls {
    constructor(container) {
      this.container = container;
      this.video = container.querySelector('video');
      this.soundButton = container.querySelector('.sound-control');
      this.enabledIcon = container.querySelector('.sound-enabled');
      this.disabledIcon = container.querySelector('.sound-disabled');

      if (!this.video || !this.soundButton) return;

      this.#init();
    }

    #init() {
      this.video.muted = true;
      this.#updateIcons();

      this.soundButton.addEventListener('click', () => this.#toggleSound());
    }

    #toggleSound() {
      this.video.muted = !this.video.muted;

      if (!this.video.muted) {
        PeopleVideoControls.muteAllExcept(this.video);
      }

      this.#updateIcons();
    }

    #updateIcons() {
      if (this.video.muted) {
        this.enabledIcon.classList.add('hidden');
        this.disabledIcon.classList.remove('hidden');
      } else {
        this.enabledIcon.classList.remove('hidden');
        this.disabledIcon.classList.add('hidden');
      }
    }

    static muteAllExcept(currentVideo) {
      const allVideoControls = document.querySelectorAll('[data-video-controls]');

      allVideoControls.forEach((container) => {
        const video = container.querySelector('video');
        const enabledIcon = container.querySelector('.sound-enabled');
        const disabledIcon = container.querySelector('.sound-disabled');

        if (video && video !== currentVideo) {
          video.muted = true;
          if (enabledIcon && disabledIcon) {
            enabledIcon.classList.add('hidden');
            disabledIcon.classList.remove('hidden');
          }
        }
      });
    }
  }

  // Initialize all video controls when DOM is ready
  const initVideoControls = () => {
    const videoContainers = document.querySelectorAll('[data-video-controls]');
    videoContainers.forEach((container) => new PeopleVideoControls(container));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoControls);
  } else {
    initVideoControls();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-showcase-v2"] && !Shopify.designMode) return;
  try {
    class ProductShowcaseSwiper {
    constructor() {
      this.swiper = null;
      this.slidesPerView = 0;
      this.init();
    }

    init() {
      const swiperElement = document.querySelector('.product-showcase-swiper');
      if (!swiperElement) return;

      this.slidesPerView = parseInt(swiperElement.dataset.slidesPerView) || 3;
      const breakpoints = this.breakpointsConfig();
      this.swiper = new Swiper('.product-showcase-swiper', {
        slidesPerView: 1.1,
        spaceBetween: 16,
        grabCursor: true,
        breakpoints: breakpoints,
      });
    }

    breakpointsConfig() {
      const breakpoints = {};

      breakpoints[768] = {
        slidesPerView: 2.1,
        spaceBetween: 16,
      };

      breakpoints[1024] = {
        slidesPerView: Math.min(3, this.slidesPerView),
        spaceBetween: 16,
      };

      breakpoints[1280] = {
        slidesPerView: Math.min(4, this.slidesPerView),
        spaceBetween: 16,
      };

      return breakpoints;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductShowcaseSwiper());
  } else {
    new ProductShowcaseSwiper();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-showcase"] && !Shopify.designMode) return;
  try {
    class ProductShowcaseSwiper {
    constructor() {
      this.swiper = null;
      this.slidesPerView = 0;
      this.init();
    }

    init() {
      const swiperElement = document.querySelector('.product-showcase-swiper');
      if (!swiperElement) return;

      this.slidesPerView = parseInt(swiperElement.dataset.slidesPerView) || 3;
      const breakpoints = this.breakpointsConfig();
      this.swiper = new Swiper('.product-showcase-swiper', {
        slidesPerView: 1.1,
        spaceBetween: 16,
        grabCursor: true,
        breakpoints: breakpoints,
      });
    }

    breakpointsConfig() {
      const breakpoints = {};

      breakpoints[768] = {
        slidesPerView: 2.1,
        spaceBetween: 16,
      };

      breakpoints[1024] = {
        slidesPerView: Math.min(3, this.slidesPerView),
        spaceBetween: 16,
      };

      breakpoints[1280] = {
        slidesPerView: Math.min(4, this.slidesPerView),
        spaceBetween: 16,
      };

      return breakpoints;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ProductShowcaseSwiper());
  } else {
    new ProductShowcaseSwiper();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["progress-carousel"] && !Shopify.designMode) return;
  try {
    class CarouselRegistry {
    constructor() {
      this.swipers = new Map();
      this.overlayManager = null;
    }

    register(id, swiper) {
      this.swipers.set(id, swiper);
    }

    get(id) {
      return this.swipers.get(id);
    }

    setOverlayManager(manager) {
      this.overlayManager = manager;
    }

    getOverlayManager() {
      return this.overlayManager;
    }
  }

  class ProgressBarController {
    constructor(element) {
      this.element = element;
    }

    update(progress) {
      if (!this.element) return;

      const percentage = Math.max(0, Math.min(100, progress * 100));
      this.element.style.width = `${percentage}%`;
    }
  }

  class CarouselController {
    static CONFIG = {
      SELECTORS: {
        container: '.progress-carousel-container',
        carousel: '.progress-carousel',
        progressBar: '.progress-bar',
        prevButton: '.button-prev',
        nextButton: '.button-next',
      },
      BREAKPOINTS: {
        tablet: 768,
        desktop: 1024,
      },
      DEFAULTS: {
        gap: 16,
        gap_mobile: 16,
        slides_per_view: 'auto',
        slides_per_view_mobile: 'auto',
        slides_per_view_tablet: 'auto',
      },
    };

    constructor(container, index, registry) {
      this.container = container;
      this.index = index;
      this.registry = registry;
      this.config = this.parseConfig();
      // this.progressController = new ProgressBarController(
      //   container.querySelector(CarouselController.CONFIG.SELECTORS.progressBar),
      // );
      this.swiper = null;
      this.totalSlides = 0;

      this.initialize();
    }

    parseConfig() {
      try {
        const configData = this.container.dataset.carouselConfig;
        return configData ? JSON.parse(configData) : {};
      } catch (error) {
        console.warn('Invalid carousel config:', error);
        return {};
      }
    }

    getSwiperConfig() {
      const cfg = { ...CarouselController.CONFIG.DEFAULTS, ...this.config };

      return {
        slidesPerView: cfg.slides_per_view_mobile,
        spaceBetween: parseInt(cfg.gap_mobile),
        breakpoints: {
          [CarouselController.CONFIG.BREAKPOINTS.tablet]: {
            slidesPerView: cfg.slides_per_view_tablet,
            spaceBetween: parseInt(cfg.gap),
          },
          [CarouselController.CONFIG.BREAKPOINTS.desktop]: {
            slidesPerView: cfg.slides_per_view,
            spaceBetween: parseInt(cfg.gap),
          },
        },
        navigation: {
          nextEl: this.container.querySelector(CarouselController.CONFIG.SELECTORS.nextButton),
          prevEl: this.container.querySelector(CarouselController.CONFIG.SELECTORS.prevButton),
        },
        on: {
          init: (swiper) => this.onInit(swiper),
          slideChange: (swiper) => this.onSlideChange(swiper),
          progress: (swiper, progress) => {
            const progressEl = this.container.querySelector(CarouselController.CONFIG.SELECTORS.progressBar);
            if (progressEl) {
              progressEl.style.width = `${Math.max(0, Math.min(100, progress * 100))}%`;
            }
          },
        },
      };
    }

    onInit(swiper) {
      this.totalSlides = swiper.slides.length;
    }

    onSlideChange(swiper) {
      const overlayManager = this.registry.getOverlayManager();
      if (!overlayManager) {
        return;
      }

      if (typeof overlayManager.onSwiperSlideChange === 'function') {
        overlayManager.onSwiperSlideChange(swiper.realIndex);
      }
    }

    initialize() {
      const carouselElement = this.container.querySelector(CarouselController.CONFIG.SELECTORS.carousel);
      if (!carouselElement) {
        return;
      }

      this.swiper = new Swiper(carouselElement, this.getSwiperConfig());
      this.registry.register(this.index, this.swiper);
      this.container.swiperInstance = this.swiper;
    }
  }

  class CarouselModule {
    static init() {
      const registry = new CarouselRegistry();
      window.carouselRegistry = registry;

      const containers = document.querySelectorAll(CarouselController.CONFIG.SELECTORS.container);
      containers.forEach((container, index) => {
        new CarouselController(container, index, registry);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => CarouselModule.init());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["promo-subscription-builder"] && !Shopify.designMode) return;
  try {
    class PromoSubscriptionBuilder {
    constructor(element) {
      this.container = element;
      this.#init();
    }

    #init() {
      this.dependantItems = this.container.querySelectorAll('[data-active-on-bundle]');
      this.bundleSwitches = this.container.querySelectorAll('[data-bundle-switch]');
      this.bundleContainers = this.container.querySelectorAll('[data-promo-bundle-select-container]');
      this.addButtons = this.container.querySelectorAll('[data-add-to-cart]');
      this.flavours = this.container.querySelectorAll('[data-flavour-quantity]');
      this.giftSelect = this.container.querySelector('[data-promo-gift-select]');
      this.stickyButton = this.container.querySelector('[data-sticky-cta-button]');
      this.addOns = this.container.querySelectorAll('[data-addon]');

      this.#updateDependantItems();
      this.#updateBundleSelectionState();
      this.#updateStickyFlavorBadge(this.#computeDistinctFlavorCount());
      this.#bindEvents();
      this.#updateAddToCartButton();
    }

    #bindEvents() {
      this.bundleSwitches.forEach((bundleSwitch) => {
        bundleSwitch.addEventListener('change', this.#handleBundleSwitch.bind(this));
      });

      this.addOns.forEach((addOn) => {
        addOn.addEventListener('change', this.#handleAddOnChange.bind(this));
      });

      this.flavours.forEach((flavour) => {
        flavour.addEventListener('change', this.#handleFlavourChange.bind(this));
      });

      if (this.giftSelect) {
        this.giftSelect.addEventListener('change', this.#handleGiftChange.bind(this));
      }
    }

    #setActiveBundle(bundleId) {
      this.container.dataset.activeBundle = bundleId;
    }

    #getActiveBundle() {
      return this.container.dataset.activeBundle;
    }

    #updateDependantItems() {
      this.dependantItems.forEach((item) => {
        item.style.display = item.dataset.activeOnBundle === this.#getActiveBundle() ? 'block' : 'none';
      });
    }

    #updateBundleSelectionState() {
      this.bundleContainers.forEach((container) => {
        const input = container.querySelector('[data-bundle-switch]');
        container.dataset.active = input && input.value === this.#getActiveBundle() ? 'true' : 'false';
      });
    }

    #updateStickyFlavorBadge(count) {
      const badge = document.querySelector('[data-sticky-flavor-count]');
      if (!badge) {
        return;
      }

      if (count > 0) {
        badge.textContent = String(count);
        badge.classList.remove('hidden');
      } else {
        badge.textContent = '';
        badge.classList.add('hidden');
      }
    }

    #handleFlavourChange() {
      this.#updateAddToCartButton();
    }

    #handleAddOnChange() {
      this.#updateAddToCartButton();
    }

    #handleGiftChange() {
      this.#updateAddToCartButton();
    }

    #handleBundleSwitch(event) {
      const oldBundleId = this.#getActiveBundle();
      const newBundleId = event.target.value;

      this.#transferFlavours(oldBundleId, newBundleId);
      this.#setActiveBundle(newBundleId);

      window.dispatchEvent(new Event('scroll'));
      this.#updateDependantItems();
      this.#updateBundleSelectionState();
      this.#updateStickyFlavorBadge(this.#computeDistinctFlavorCount());
      this.#updateAddToCartButton();
    }

    #transferFlavours(oldBundleId, newBundleId) {
      if (!oldBundleId || !newBundleId || oldBundleId === newBundleId) {
        return;
      }

      const sourceGroup = this.#getProductGroup(oldBundleId);
      const targetGroup = this.#getProductGroup(newBundleId);
      if (!sourceGroup || !targetGroup) {
        return;
      }

      const sourceInputs = this.#getGroupFlavours(sourceGroup);
      const targetInputs = this.#getGroupFlavours(targetGroup);
      const targetLimit = parseInt(targetGroup.dataset.totalLimit) || 3;

      this.#resetTargetSelections(targetInputs);

      const targetInputsByIndex = this.#buildIndexMap(targetInputs);
      const selectedSourceFlavors = this.#collectSelectedFlavors(sourceInputs);

      let currentTargetTotal = 0;
      for (const { idx, qty } of selectedSourceFlavors) {
        if (currentTargetTotal >= targetLimit) {
          break;
        }

        const targetInput = targetInputsByIndex[idx];
        if (!targetInput) {
          continue;
        }

        const transferableQty = Math.min(qty, targetLimit - currentTargetTotal);
        targetInput.value = String(transferableQty);
        currentTargetTotal += transferableQty;
      }

      this.#dispatchUpdateGroup(sourceGroup);
      this.#dispatchUpdateGroup(targetGroup);
    }

    #getGroupFlavours(group) {
      return Array.from(group.querySelectorAll('[data-flavour-quantity]'));
    }

    #getProductGroup(bundleId) {
      return this.container.querySelector(`[data-active-on-bundle="${bundleId}"] [data-product-group]`);
    }

    #resetTargetSelections(targetInputs) {
      targetInputs.forEach((input) => {
        input.value = '0';
      });
    }

    #buildIndexMap(inputs) {
      const map = {};
      inputs.forEach((input) => {
        const idx = parseInt(input.dataset.index);
        if (!Number.isNaN(idx)) {
          map[idx] = input;
        }
      });

      return map;
    }

    #collectSelectedFlavors(inputs) {
      return inputs
        .map((input) => ({
          idx: parseInt(input.dataset.index),
          qty: parseInt(input.value) || 0,
        }))
        .filter(({ idx, qty }) => !Number.isNaN(idx) && qty > 0)
        .sort((a, b) => a.idx - b.idx);
    }

    #dispatchUpdateGroup(productGroup) {
      productGroup.dispatchEvent(new CustomEvent('bundle:refresh', { bubbles: true }));
    }

    #getActiveSellingPlan() {
      const checkedBundle = this.container.querySelector('[data-bundle-switch]:checked');
      return checkedBundle ? checkedBundle.dataset.sellingPlan || '' : '';
    }

    #updateAddToCartButton() {
      const bundleId = this.#getActiveBundle();
      const sellingPlan = this.#getActiveSellingPlan();
      const giftVariant = this.giftSelect ? this.giftSelect.value : '';
      const variants = [];

      this.flavours.forEach((flavour) => {
        if (parseInt(flavour.value) === 0) {
          return;
        }

        if (bundleId !== flavour.dataset.bundleVariantId) {
          return;
        }

        for (let i = 0; i < flavour.value; i++) {
          variants.push(flavour.dataset.variantId);
        }
      });

      this.addButtons.forEach((addButton) => {
        if (bundleId !== addButton.dataset.activeOnBundle) {
          return;
        }

        addButton.dataset.variants = variants.join(',');
        addButton.dataset.sellingPlan = sellingPlan;
        const bundleInput = this.container.querySelector(`[data-bundle-switch][value="${bundleId}"]`);
        const bundleContainer = bundleInput ? bundleInput.closest('.bundle-select-container') : null;
        const addOn = bundleContainer ? bundleContainer.querySelector('[data-addon]:checked') : null;
        addButton.dataset.addOn = sellingPlan && addOn ? addOn.value : '';
        addButton.dataset.promoGift = giftVariant;

        const distinctCount = new Set(variants).size;
        this.#updateStickyFlavorBadge(distinctCount);

        const minimumAmount = parseInt(addButton.dataset.minimumAmount) || 0;
        const remainingFlavors = minimumAmount - variants.length;
        const isDisabled = variants.length < minimumAmount || !sellingPlan || !giftVariant;
        addButton.disabled = isDisabled;

        if (this.stickyButton) {
          this.stickyButton.dataset.disabled = isDisabled;
          this.stickyButton.textContent = isDisabled ? 'Build your Bundle' : 'Subscribe now';
        }

        const buttonText = addButton.querySelector('[data-button-text]');
        if (!buttonText) {
          return;
        }

        if (!giftVariant) {
          buttonText.textContent = 'Gift unavailable';
          return;
        }

        switch (remainingFlavors) {
          case 0:
            buttonText.textContent = 'Subscribe now';
            break;
          case 1:
            buttonText.textContent = 'Nearly there! Add 1 more';
            break;
          case 2:
            buttonText.textContent = `Good start! Add ${remainingFlavors} more`;
            break;
          default:
            buttonText.textContent = `Pick ${minimumAmount} for your bundle`;
        }
      });
    }

    #computeDistinctFlavorCount() {
      const bundleId = this.#getActiveBundle();
      const selected = [];
      this.flavours.forEach((flavour) => {
        if (parseInt(flavour.value) === 0) {
          return;
        }

        if (bundleId === flavour.dataset.bundleVariantId) {
          selected.push(flavour.dataset.variantId);
        }
      });

      return new Set(selected).size;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-promo-subscription-builder]');
    if (container) {
      new PromoSubscriptionBuilder(container);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["select-bundle-v2"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const radioButtons = document.querySelectorAll('input[data-bundle-switch]');

    radioButtons.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const containers = document.querySelectorAll('.bundle-select-container');

        containers.forEach((container) => {
          container.setAttribute('data-active', 'false');
        });

        const selectedContainer = event.target.closest('.bundle-select-container');
        if (selectedContainer) {
          selectedContainer.setAttribute('data-active', 'true');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["select-bundle"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const radioButtons = document.querySelectorAll('input[data-bundle-switch]');

    radioButtons.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        const containers = document.querySelectorAll('.bundle-select-container');

        containers.forEach((container) => {
          container.setAttribute('data-active', 'false');
        });

        const selectedContainer = event.target.closest('.bundle-select-container');
        if (selectedContainer) {
          selectedContainer.setAttribute('data-active', 'true');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["single-bundle-container"] && !Shopify.designMode) return;
  try {
    class SingleBundleContainer {
    constructor(element) {
      this.container = element;
      this.bundleId = this.container.dataset.activeBundle;
      this.sellingPlan = this.container.dataset.sellingPlan || '';
      this.addButtons = this.container.querySelectorAll('[data-add-to-cart]');
      this.flavours = this.container.querySelectorAll('[data-flavour-quantity]');
      this.addOns = this.container.querySelectorAll('[data-addon]');
      this.stickyButton = this.container.querySelector('[data-sticky-cta-button]');
      this.#bindEvents();
      this.#updateAddToCartButton();
    }

    #bindEvents() {
      this.flavours.forEach((flavour) => {
        flavour.addEventListener('change', this.#updateAddToCartButton.bind(this));
      });
      this.addOns.forEach((addOn) => {
        addOn.addEventListener('change', this.#updateAddToCartButton.bind(this));
      });
    }

    #selectedVariants() {
      const variants = [];

      this.flavours.forEach((flavour) => {
        const quantity = parseInt(flavour.value, 10) || 0;
        if (quantity === 0 || flavour.dataset.bundleVariantId !== this.bundleId) {
          return;
        }

        for (let index = 0; index < quantity; index += 1) {
          variants.push(flavour.dataset.variantId);
        }
      });

      return variants;
    }

    #updateStickyFlavorBadge(variants) {
      const badge = this.container.querySelector('[data-sticky-flavor-count]');
      if (!badge) {
        return;
      }

      const distinctCount = new Set(variants).size;
      badge.textContent = distinctCount > 0 ? String(distinctCount) : '';
      badge.classList.toggle('hidden', distinctCount === 0);
    }

    #updateAddToCartButton() {
      const variants = this.#selectedVariants();
      const selectedAddOn = this.container.querySelector('[data-addon]:checked');

      this.#updateStickyFlavorBadge(variants);

      this.addButtons.forEach((addButton) => {
        addButton.dataset.variants = variants.join(',');
        addButton.dataset.sellingPlan = this.sellingPlan;
        addButton.dataset.addOn = selectedAddOn ? selectedAddOn.value : '';

        const minimumAmount = parseInt(addButton.dataset.minimumAmount, 10) || 0;
        const remainingFlavors = Math.max(minimumAmount - variants.length, 0);
        const isDisabled = variants.length < minimumAmount;
        addButton.disabled = isDisabled;

        if (this.stickyButton) {
          this.stickyButton.dataset.disabled = String(isDisabled);
          this.stickyButton.textContent = isDisabled ? 'Build your Bundle' : 'Subscribe now';
        }

        const buttonText = addButton.querySelector('[data-button-text]');
        if (!buttonText) {
          return;
        }

        switch (remainingFlavors) {
          case 0:
            buttonText.textContent = this.sellingPlan ? 'Subscribe now' : 'Add to basket';
            break;
          case 1:
            buttonText.textContent = 'Nearly there! Add 1 more';
            break;
          case 2:
            buttonText.textContent = `Good start! Add ${remainingFlavors} more`;
            break;
          default:
            buttonText.textContent = `Pick ${minimumAmount} for your bundle`;
        }
      });
    }
  }

  const initializeSingleBundleContainers = () => {
    document.querySelectorAll('[data-single-bundle-container]').forEach((container) => {
      if (container.dataset.singleBundleInitialized === 'true') {
        return;
      }

      container.dataset.singleBundleInitialized = 'true';
      new SingleBundleContainer(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSingleBundleContainers);
  } else {
    initializeSingleBundleContainers();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["single-product-container-v2"] && !Shopify.designMode) return;
  try {
    class PackContainerV2 {
    constructor(element) {
      this.container = element;
      this.#init();
    }

    #init() {
      this.addButtons = this.container.querySelectorAll('[data-add-to-cart]');
      this.variantLinks = this.container.querySelectorAll('[data-change-variant]');
      this.variantInputs = this.container.querySelectorAll('input[name="variant"]');
      this.bundleInputs = this.container.querySelectorAll('input[name="bundle"]');
      this.stickyButton = this.container.querySelector('[data-sticky-cta-button]');

      this.#bindEvents();
      this.#updateAddToCartButton();
    }

    #getActiveBundle() {
      return this.container.querySelector('input[name="bundle"]:checked').value;
    }

    #bindEvents() {
      this.variantInputs.forEach((input) => {
        input.addEventListener('change', () => this.#updateAddToCartButton());
      });

      this.bundleInputs.forEach((input) => {
        input.addEventListener('change', () => this.#updateAddToCartButton());
      });

      this.variantLinks.forEach((variantLink) => {
        variantLink.addEventListener('click', this.#handleVariantLinkClick.bind(this));
      });
    }

    #handleVariantLinkClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const scrollLocation = window.scrollY;
      const url = new URL(target.href);
      url.hash = 's:' + scrollLocation;
      window.location.href = url.toString();
    }

    #updateAddToCartButton() {
      const selectedVariant = this.container.querySelector('input[name="variant"]:checked');
      const selectedBundle = this.container.querySelector('input[name="bundle"]:checked');
      if (!selectedVariant || !selectedBundle) return;

      this.addButtons.forEach((addButton) => {
        addButton.dataset.sellingPlan = '';
        addButton.dataset.addOn = '';
        addButton.dataset.disableAutoBundle = 'false';

        switch (selectedBundle.value) {
          case '2x12':
            addButton.dataset.type = '2x12';
            addButton.dataset.variants = selectedVariant.value + ',' + selectedVariant.value;
            break;
          case '3x12':
            addButton.dataset.type = 'build-your-own';
            addButton.dataset.variants =
              selectedVariant.value + ',' + selectedVariant.value + ',' + selectedVariant.value;
            break;
          default:
            addButton.dataset.type = '';
            addButton.dataset.variants = selectedVariant.value;
            addButton.dataset.disableAutoBundle = 'true';
            break;
        }
      });

      if (this.stickyButton) {
        this.stickyButton.dataset.disabled = 'false';
        this.stickyButton.textContent = 'Add to basket';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-single-product-container-v2]');
    if (container) {
      new PackContainerV2(container);
    }
  });

  const hash = window.location.hash;
  if (hash && hash.includes('s:')) {
    const scrollLocation = hash.split(':')[1];
    window.scrollTo({
      top: scrollLocation,
      left: 0,
      behavior: 'instant',
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["single-product-container"] && !Shopify.designMode) return;
  try {
    class PackContainer {
    constructor(element) {
      this.container = element;
      this.#init();
    }

    #init() {
      this.addButtons = this.container.querySelectorAll('[data-add-to-cart]');
      this.variantLinks = this.container.querySelectorAll('[data-change-variant]');
      this.variantInputs = this.container.querySelectorAll('input[name="variant"]');
      this.bundleInputs = this.container.querySelectorAll('input[name="bundle"]');
      this.dependantItems = this.container.querySelectorAll('[data-active-on-bundle]');
      this.planSwitches = this.container.querySelectorAll('[data-plan-switch]');
      this.sellingPlans = this.container.querySelectorAll('[data-selling-plan]');
      this.addOns = this.container.querySelectorAll('[data-addon]');
      this.stickyButton = this.container.querySelector('[data-sticky-cta-button]');

      this.#bindEvents();
      this.#updateDependantItems();
      this.#updateAddToCartButton();
    }

    #getActiveBundle() {
      return this.container.querySelector('input[name="bundle"]:checked').value;
    }

    #updateDependantItems() {
      this.dependantItems.forEach((item) => {
        item.style.display = item.dataset.activeOnBundle === this.#getActiveBundle() ? 'flex' : 'none';
      });
    }

    #bindEvents() {
      this.variantInputs.forEach((input) => {
        input.addEventListener('change', this.#handleVariantInputChange.bind(this));
      });

      this.bundleInputs.forEach((input) => {
        input.addEventListener('change', this.#handleBundleInputChange.bind(this));
      });

      this.planSwitches.forEach((planSwitch) => {
        planSwitch.addEventListener('change', this.#handlePlanSwitch.bind(this));
      });

      this.sellingPlans.forEach((sellingPlan) => {
        sellingPlan.addEventListener('change', this.#handleSellingPlanChange.bind(this));
      });

      this.addOns.forEach((addOn) => {
        addOn.addEventListener('change', this.#handleAddOnChange.bind(this));
      });

      this.variantLinks.forEach((variantLink) => {
        variantLink.addEventListener('click', this.#handleVariantLinkClick.bind(this));
      });
    }

    #handleVariantLinkClick(event) {
      event.preventDefault();
      // add current scroll location as a hashtag to the url
      // and redirect to the new url.
      const target = event.currentTarget;
      const scrollLocation = window.scrollY;
      const url = new URL(target.href);
      url.hash = 's:' + scrollLocation;
      window.location.href = url.toString();
    }

    #handleVariantInputChange(event) {
      this.#updateAddToCartButton();
    }

    #handleBundleInputChange(event) {
      this.#updateDependantItems();
      this.#selectActiveSubscription(event);
      this.#updateAddToCartButton();
    }

    #handleAddOnChange(event) {
      this.#selectPlan(event);
      this.#updateAddToCartButton();
    }

    #handlePlanSwitch(event) {
      this.#updateAddToCartButton();
    }

    #handleSellingPlanChange(event) {
      this.#selectPlan(event);
      this.#updateAddToCartButton();
    }

    #selectActiveSubscription() {
      const activeBundle = this.#getActiveBundle();
      const planContainer = this.container.querySelector(
        `[data-bundle-plans-container][data-active-on-bundle="${activeBundle}"]`,
      );
      if (planContainer) {
        const plan = planContainer.querySelector('input[value="subscription"]');
        if (plan) {
          plan.checked = true;
          plan.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // if event happened in one of the plan containers, then
    // automatically select the plan.
    #selectPlan(event) {
      const container = event.target.closest('[data-bundle-plan-container]');
      const plan = container.querySelector('[data-plan-switch]');
      if (plan) {
        plan.checked = true;
        plan.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // goes through all container inputs and gathers data
    // required for add to cart button to create a bundle.
    #updateAddToCartButton() {
      const selectedVariant = this.container.querySelector('input[name="variant"]:checked');
      const selectedBundle = this.container.querySelector('input[name="bundle"]:checked');
      if (!selectedVariant || !selectedBundle) return;

      const planContainer = this.container.querySelector(
        `[data-bundle-plans-container][data-active-on-bundle="${selectedBundle.value}"]`,
      );

      const variants = [];
      let plan, sellingPlan, addOn;

      if (planContainer) {
        plan = planContainer.querySelector('[data-plan-switch]:checked');
        sellingPlan = planContainer.querySelector('[data-selling-plan]');
        addOn = planContainer.querySelector('[data-variant-switch]:checked');
      }

      this.addButtons.forEach((addButton) => {
        addButton.dataset.type = selectedBundle.value;
        addButton.dataset.disableAutoBundle = 'false';

        switch (selectedBundle.value) {
          case '2x12':
            addButton.dataset.variants = selectedVariant.value + ',' + selectedVariant.value;
            break;
          case '3x12':
            addButton.dataset.variants =
              selectedVariant.value + ',' + selectedVariant.value + ',' + selectedVariant.value;
            break;
          default:
            addButton.dataset.type = '';
            addButton.dataset.variants = selectedVariant.value;
            addButton.dataset.disableAutoBundle = 'true';
            break;
        }

        addButton.dataset.sellingPlan = plan && plan.value === 'subscription' ? sellingPlan.value : '';
        addButton.dataset.addOn = addOn && plan.value === 'subscription' ? addOn.value : '';
      });

      if (this.stickyButton) {
        this.stickyButton.dataset.disabled = 'false';
        const isSubscription = plan ? plan.value === 'subscription' : false;
        this.stickyButton.textContent = isSubscription ? 'Subscribe now' : 'Add to basket';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-single-product-container]');
    if (container) {
      new PackContainer(container);
    }
  });

  // before the page is loaded, scroll to the location specified in the hash
  const hash = window.location.hash;
  if (hash && hash.includes('s:')) {
    const scrollLocation = hash.split(':')[1];
    window.scrollTo({
      top: scrollLocation,
      left: 0,
      behavior: 'instant',
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["text-slide-in"] && !Shopify.designMode) return;
  try {
    function initTextSlideIn(container) {
    const words = container.querySelectorAll('.text-slide-word');

    words.forEach((word, index) => {
      setTimeout(
        () => {
          word.classList.add('animate');
        },
        200 + index * 50,
      );
    });
  }

  // Initialize all text slide containers
  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.text-slide-container');
    containers.forEach((container) => {
      initTextSlideIn(container);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trial-pack"] && !Shopify.designMode) return;
  try {
    class TrialPack {
    constructor(element) {
      this.container = element;
      this.#init();
    }

    #init() {
      if (this.container.dataset.trialPackReady === 'true') {
        return;
      }

      this.container.dataset.trialPackReady = 'true';
      this.addButtons = this.container.querySelectorAll('[data-add-to-cart]');
      this.variantOptions = this.container.querySelectorAll('[data-trial-variant-option]');
      this.variantInputs = this.container.querySelectorAll('[data-trial-variant-input]');
      this.mediaPanels = this.container.querySelectorAll('[data-trial-media-panel]');
      this.mobileTitle = this.container.querySelector('[data-trial-mobile-title]');
      this.mobileDescription = this.container.querySelector('[data-trial-mobile-description]');
      this.price = this.container.querySelector('[data-trial-price]');
      this.comparePrice = this.container.querySelector('[data-trial-compare-price]');
      this.stickyButton = this.container.querySelector('[data-sticky-cta-button]');

      this.variantInputs.forEach((input) => {
        input.addEventListener('change', this.#handleVariantChange.bind(this));
      });

      this.variantOptions.forEach((option) => {
        option.addEventListener('click', this.#handleVariantOptionClick.bind(this));
      });

      this.#syncSelectedVariant();
    }

    #getSelectedInput() {
      return this.container.querySelector('[data-trial-variant-input]:checked');
    }

    #getVariantData(input) {
      return input?.closest('[data-trial-variant-option]');
    }

    #handleVariantChange() {
      this.#syncSelectedVariant();
    }

    #handleVariantOptionClick(event) {
      const input = event.currentTarget.querySelector('[data-trial-variant-input]');
      if (!input || input.checked) {
        return;
      }

      input.checked = true;
      this.#syncSelectedVariant();
    }

    #syncSelectedVariant() {
      const input = this.#getSelectedInput();
      const variantData = this.#getVariantData(input);
      if (!input || !variantData) {
        return;
      }

      this.addButtons.forEach((addButton) => {
        addButton.dataset.type = '';
        addButton.dataset.variants = input.value;
        addButton.dataset.sellingPlan = '';
        addButton.dataset.addOn = '';
      });

      this.#updateMedia(input.value);
      this.#updateContent(variantData);
      this.#updateStickyCta(variantData);

      if (this.stickyButton) {
        this.stickyButton.dataset.disabled = 'false';
        this.stickyButton.textContent = 'Add to basket';
      }
    }

    #updateMedia(variantId) {
      let activePanel = null;
      this.mediaPanels.forEach((panel) => {
        const isActive = panel.dataset.variantId === variantId;
        panel.classList.toggle('hidden', !isActive);
        if (isActive) {
          activePanel = panel;
        }
      });

      if (!activePanel) {
        return;
      }

      window.requestAnimationFrame(() => {
        activePanel.querySelectorAll('.bundle-media').forEach((carousel) => {
          if (carousel.swiper) {
            carousel.swiper.update();
            carousel.swiper.slideTo(0, 0);
          }
        });
      });
    }

    #updateContent(variantData) {
      const title = variantData.dataset.titleHtml || '';
      const description = variantData.dataset.descriptionHtml || '';

      if (this.mobileTitle) {
        this.mobileTitle.innerHTML = title;
      }

      if (this.mobileDescription) {
        this.mobileDescription.innerHTML = description;
        this.mobileDescription.classList.toggle('hidden', description === '');
      }

      const desktopTitle = document.querySelector('[data-single-product-heading-title]');
      if (desktopTitle) {
        desktopTitle.innerHTML = title;
      }

      const desktopDescription = document.querySelector('[data-single-product-heading-description]');
      const desktopDescriptionWrapper = document.querySelector('[data-single-product-heading-description-wrapper]');
      if (desktopDescription && desktopDescriptionWrapper) {
        desktopDescription.innerHTML = description;
        desktopDescriptionWrapper.classList.toggle('hidden', description === '');
      }

      if (this.price) {
        this.price.innerHTML = variantData.dataset.priceHtml || '';
      }

      if (this.comparePrice) {
        const showCompare = variantData.dataset.showCompare === 'true';
        this.comparePrice.innerHTML = showCompare ? variantData.dataset.comparePriceHtml || '' : '';
        this.comparePrice.classList.toggle('hidden', !showCompare);
      }
    }

    #updateStickyCta(variantData) {
      const iconUrl = variantData.dataset.iconUrl;
      if (!iconUrl) {
        return;
      }

      const stickyIcon = this.container.querySelector('[data-sticky-product-icon]');
      if (stickyIcon) {
        stickyIcon.src = iconUrl;
      }
    }
  }

  function initTrialPacks(root = document) {
    root.querySelectorAll('[data-trial-pack]').forEach((container) => new TrialPack(container));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTrialPacks());
  } else {
    initTrialPacks();
  }

  document.addEventListener('shopify:section:load', (event) => initTrialPacks(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trustpilots"] && !Shopify.designMode) return;
  try {
    class TrustpilotsSwiper {
    constructor() {
      this.swiper = null;
      this.slidesPerView = 0;
      this.init();
    }

    init() {
      const swiperElement = document.querySelector('.trustpilots-swiper');
      if (!swiperElement) return;

      this.slidesPerView = parseInt(swiperElement.dataset.slidesPerView) || 5;
      const breakpoints = this.breakpointsConfig();
      this.swiper = new Swiper('.trustpilots-swiper', {
        slidesPerView: 1.1,
        spaceBetween: 12,
        grabCursor: true,
        breakpoints: breakpoints,
      });
    }

    breakpointsConfig() {
      const breakpoints = {};

      breakpoints[768] = {
        slidesPerView: 3.1,
        spaceBetween: 12,
      };

      breakpoints[1024] = {
        slidesPerView: Math.min(4, this.slidesPerView),
        spaceBetween: 12,
      };

      breakpoints[1280] = {
        slidesPerView: Math.min(5, this.slidesPerView),
        spaceBetween: 12,
      };

      return breakpoints;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new TrustpilotsSwiper());
  } else {
    new TrustpilotsSwiper();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["value-proposition-item"] && !Shopify.designMode) return;
  try {
    class ProgressCarouselMobileOverlayManager {
    constructor() {
      this.template = null;
      this.activeOverlay = null;
      this.items = [];
      this.currentIndex = 0;
      this.swiper = null;
      this.isUpdatingFromSwiper = false;
      this.syncTimeout = null;
      this.animationDuration = 300;

      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handlePrev = this.handlePrev.bind(this);
      this.handleNext = this.handleNext.bind(this);

      this.initialize();
    }

    initialize() {
      this.template = document.getElementById('value-prop-overlay-template');
      if (!this.template) {
        console.warn('Overlay template not found');
      }
    }

    init(items = [], swiperInstance = null) {
      this.items = items;
      this.swiper = swiperInstance;

      if (window.carouselRegistry) {
        window.carouselRegistry.setOverlayManager(this);
      }

      return this;
    }

    onSwiperSlideChange(newIndex) {
      if (this.isUpdatingFromSwiper || !this.activeOverlay) {
        return;
      }

      this.currentIndex = newIndex;
      this.render();
    }

    createOverlayElement() {
      if (!this.template) {
        return null;
      }

      const fragment = this.template.content.cloneNode(true);
      return fragment.querySelector('.value-proposition-mobile-overlay') || fragment.firstElementChild;
    }

    render() {
      if (!this.activeOverlay || !this.items.length) {
        return;
      }

      const clampedIndex = Math.max(0, Math.min(this.currentIndex, this.items.length - 1));
      this.currentIndex = clampedIndex;

      const data = this.items[this.currentIndex];
      if (!data) {
        return;
      }

      this.updateContent(data);
      this.updateProgress();
      this.updateNavigation();
      this.syncWithSwiper();
    }

    updateContent(data) {
      const elements = {
        image: this.activeOverlay.querySelector('.overlay-image'),
        tag: this.activeOverlay.querySelector('.overlay-tag'),
        description: this.activeOverlay.querySelector('.overlay-description'),
      };

      if (elements.image && data.image) {
        elements.image.src = data.image;
        elements.image.alt = data.title || '';
      }

      if (elements.tag) {
        elements.tag.textContent = data.title || '';
      }

      if (elements.description) {
        elements.description.textContent = data.description || '';
      }
    }

    updateProgress() {
      const progressBar = this.activeOverlay.querySelector('.overlay-progress-bar');
      if (!progressBar || this.items.length == 0) {
        return;
      }

      const steps = this.items.length - 1;
      const progress = (this.currentIndex / steps) * 100;
      progressBar.style.width = `${Math.max(0, Math.min(100, progress))}%`;
    }

    updateNavigation() {
      const prevBtn = this.activeOverlay.querySelector('.overlay-nav-prev');
      const nextBtn = this.activeOverlay.querySelector('.overlay-nav-next');

      const hasPrev = this.currentIndex > 0;
      const hasNext = this.currentIndex < this.items.length - 1;

      this.toggleButtonState(prevBtn, hasPrev);
      this.toggleButtonState(nextBtn, hasNext);
    }

    toggleButtonState(btn, enabled) {
      if (!btn) {
        return;
      }

      btn.disabled = !enabled;
      btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
      btn.classList.toggle('disabled', !enabled);

      const paths = btn.querySelectorAll('path');
      paths.forEach((path) => {
        path.setAttribute('stroke', enabled ? '#ffffff' : '#92979b');
      });
    }

    syncWithSwiper() {
      if (!this.swiper || this.swiper.activeIndex === this.currentIndex) {
        return;
      }

      if (this.syncTimeout) {
        clearTimeout(this.syncTimeout);
      }

      this.isUpdatingFromSwiper = true;
      this.swiper.slideTo(this.currentIndex, this.animationDuration);

      this.syncTimeout = setTimeout(() => {
        this.isUpdatingFromSwiper = false;
        this.syncTimeout = null;
      }, this.animationDuration + 100);
    }

    bindEvents() {
      if (!this.activeOverlay) return;

      const elements = {
        closeBtn: this.activeOverlay.querySelector('.overlay-close-btn'),
        prevBtn: this.activeOverlay.querySelector('.overlay-nav-prev'),
        nextBtn: this.activeOverlay.querySelector('.overlay-nav-next'),
        content: this.activeOverlay.querySelector('[role="dialog"]'),
        background: this.activeOverlay,
      };

      if (elements.closeBtn) {
        elements.closeBtn.addEventListener('click', this.handleClose);
      }

      if (elements.prevBtn) {
        elements.prevBtn.addEventListener('click', this.handlePrev);
      }

      if (elements.nextBtn) {
        elements.nextBtn.addEventListener('click', this.handleNext);
      }

      elements.background.addEventListener('click', (backgroundEvent) => {
        if (backgroundEvent.target === elements.background) {
          this.close();
        }
      });

      if (elements.content) {
        elements.content.addEventListener('click', (contentEvent) => contentEvent.stopPropagation());
      }
    }

    handleClose(event) {
      event.preventDefault();
      this.close();
    }

    handlePrev(event) {
      event.preventDefault();
      this.showPrev();
    }

    handleNext(event) {
      event.preventDefault();
      this.showNext();
    }

    handleKeydown(event) {
      if (!this.activeOverlay) {
        return;
      }

      switch (event.key) {
        case 'Escape':
          event.preventDefault();
          this.close();
          break;
        case 'ArrowLeft':
          event.preventDefault();
          this.showPrev();
          break;
        case 'ArrowRight':
          event.preventDefault();
          this.showNext();
          break;
      }
    }

    open(index = 0) {
      if (!this.template) {
        return;
      }

      this.close();
      this.activeOverlay = this.createOverlayElement();

      if (!this.activeOverlay) {
        return;
      }

      document.body.appendChild(this.activeOverlay);
      this.bindEvents();

      this.currentIndex = Math.max(0, Math.min(index, this.items.length - 1));
      this.render();

      this.lockBodyScroll(true);
      requestAnimationFrame(() => {
        this.activeOverlay.classList.remove('pointer-events-none', 'opacity-0');
        this.activeOverlay.classList.add('opacity-100');
      });

      document.addEventListener('keydown', this.handleKeydown);
      const dialog = this.activeOverlay.querySelector('[role="dialog"]') || this.activeOverlay;
      if (!dialog) {
        return;
      }

      dialog.focus();
    }

    close() {
      if (!this.activeOverlay) {
        return;
      }

      if (this.syncTimeout) {
        clearTimeout(this.syncTimeout);
        this.syncTimeout = null;
      }
      this.isUpdatingFromSwiper = false;

      this.lockBodyScroll(false);

      this.activeOverlay.classList.add('opacity-0');
      this.activeOverlay.classList.remove('opacity-100');

      setTimeout(() => {
        if (this.activeOverlay) {
          this.activeOverlay.remove();
          this.activeOverlay = null;
        }
      }, this.animationDuration);

      document.removeEventListener('keydown', this.handleKeydown);
    }

    showPrev() {
      if (this.currentIndex <= 0) {
        return;
      }

      this.currentIndex--;
      this.render();
    }

    showNext() {
      if (this.currentIndex >= this.items.length - 1) {
        return;
      }

      this.currentIndex++;
      this.render();
    }

    lockBodyScroll(lock) {
      if (lock) {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }

    isOpen() {
      return Boolean(this.activeOverlay);
    }
  }

  class ValuePropositionItem {
    static instances = new Map();

    constructor(element, index) {
      this.element = element;
      this.index = index;
      this.isExpanded = false;
      this.isAnimating = false;

      this.config = this.parseConfig();

      this.queryElements();
      this.initialize();
      ValuePropositionItem.instances.set(element, this);
    }

    parseConfig() {
      return {
        title: this.element.dataset.title || 'Title',
        description: this.element.dataset.description || 'Description',
        image: this.element.dataset.image || '',
        buttonText: this.element.dataset.buttonText || 'Learn More',
        buttonUrl: this.element.dataset.buttonUrl || '#',
        expandedWidth: parseInt(this.element.dataset.expandedWidth) || 900,
        originalWidth: parseInt(this.element.dataset.itemWidth) || 420,
        containerHeight: parseInt(this.element.dataset.itemHeight) || 600,
        animationDuration: 200,
      };
    }

    queryElements() {
      this.elements = {
        trigger: this.element.querySelector('.value-proposition-trigger'),
        title: this.element.querySelector('.value-proposition-item-title'),
        description: this.element.querySelector('.carousel-item-description'),
      };
    }

    initialize() {
      if (this.elements.trigger) {
        this.elements.trigger.addEventListener('click', (e) => this.handleClick(e));
      }
    }

    get isMobile() {
      const mobileBreakpoint = 768;
      return window.innerWidth < mobileBreakpoint;
    }

    get overlayManager() {
      const registry = window.carouselRegistry;
      if (!registry) {
        return;
      }

      return registry.getOverlayManager();
    }

    get swiper() {
      const container = this.element.closest('.progress-carousel-container');
      if (!container) {
        return;
      }

      return container?.swiperInstance;
    }

    async handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.isAnimating) {
        return;
      }

      if (this.isMobile) {
        this.openMobileOverlay();
        return;
      }

      await this.handleDesktopClick();
    }

    openMobileOverlay() {
      const overlayManager = this.overlayManager;
      const swiper = this.swiper;

      if (overlayManager) {
        const currentIndex = swiper ? swiper.activeIndex : this.index;
        overlayManager.open(currentIndex);
      }
    }

    async handleDesktopClick() {
      const swiper = this.swiper;
      if (!swiper) {
        return;
      }

      const slideIndex = Array.from(swiper.slides).indexOf(this.element);
      await this.collapseOthers();

      if (this.isExpanded) {
        await this.collapse();
        swiper.update();
        swiper.slideTo(slideIndex - 1);
      } else {
        await this.expand();
        swiper.update();
        swiper.slideTo(slideIndex);
      }
    }

    async collapseOthers() {
      const promises = [];

      ValuePropositionItem.instances.forEach((instance, element) => {
        if (instance !== this && instance.isExpanded) {
          promises.push(instance.collapse());
        }
      });

      await Promise.all(promises);
    }

    async expand() {
      if (this.isExpanded || this.isAnimating) return;

      this.isAnimating = true;
      this.isExpanded = true;
      this.element.classList.add('expanded');

      if (this.elements.title) {
        const bounding = this.elements.title.getBoundingClientRect();
        const currentWidth = bounding.width;
        this.elements.title.style.width = `${currentWidth}px`;
        this.elements.title.style.maxWidth = `${currentWidth}px`;
      }

      const titleTransform = this.config.containerHeight - this.elements.title.offsetHeight - 48;

      const animations = [];

      if (this.elements.title) {
        animations.push(
          this.animate(this.elements.title, {
            transform: `translateY(-${titleTransform}px)`,
          }),
        );
      }

      if (this.elements.trigger) {
        animations.push(
          this.animate(this.elements.trigger, {
            transform: 'rotate(45deg)',
          }),
        );
      }

      animations.push(
        this.animate(this.element, {
          maxWidth: `${this.config.expandedWidth}px`,
        }),
      );

      if (this.elements.description) {
        animations.push(
          this.animate(this.elements.description, {
            opacity: 1,
            bottom: '0px',
          }),
        );
      }

      await Promise.all(animations);

      this.isAnimating = false;
    }

    async collapse() {
      if (!this.isExpanded || this.isAnimating) {
        return;
      }

      this.isAnimating = true;
      this.isExpanded = false;
      this.element.classList.remove('expanded');

      const animations = [];
      if (this.elements.description) {
        animations.push(
          this.animate(this.elements.description, {
            opacity: 0,
            bottom: '-100px',
          }),
        );
      }

      if (this.elements.title) {
        animations.push(
          this.animate(this.elements.title, {
            transform: 'translateY(0)',
          }),
        );
      }

      if (this.elements.trigger) {
        animations.push(
          this.animate(this.elements.trigger, {
            transform: 'rotate(0deg)',
          }),
        );
      }

      animations.push(
        this.animate(this.element, {
          maxWidth: `${this.config.originalWidth}px`,
        }),
      );

      await Promise.all(animations);
      this.isAnimating = false;

      if (this.elements.title) {
        this.elements.title.style.width = '';
        this.elements.title.style.maxWidth = '';
      }
    }

    animate(element, properties) {
      return new Promise((resolve) => {
        const motionAnimate = window?.Motion?.animate;
        if (!motionAnimate) {
          resolve();
        }

        motionAnimate(element, properties, {
          duration: this.config.animationDuration / 1000,
          easing: 'easeInOut',
        }).finished.then(resolve);
      });
    }

    destroy() {
      if (this.elements.trigger) {
        this.elements.trigger.removeEventListener('click', this.handleClick);
      }
      ValuePropositionItem.instances.delete(this.element);
    }

    static initializeAll() {
      const items = [];
      let swiperInstance = null;

      const registry = window.carouselRegistry;
      if (registry && registry?.swipers.size > 0) {
        swiperInstance = Array.from(registry.swipers.values())[0];
      }

      const propositionElements = document.querySelectorAll('.value-proposition-item');
      propositionElements.forEach((element, index) => {
        const instance = new ValuePropositionItem(element, index);

        const itemData = {
          title: instance.config.title,
          description: instance.config.description,
          image: instance.config.image,
          buttonText: instance.config.buttonText || 'Learn More',
          buttonUrl: instance.config.buttonUrl || '#',
        };

        items.push(itemData);
      });

      const overlayManager = new ProgressCarouselMobileOverlayManager();
      overlayManager.init(items, swiperInstance);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    ValuePropositionItem.initializeAll();
  });
  } catch(e) { console.error(e); }
})();

})();
